import { _log } from './utils/logger';

var ImageFilters = {};
ImageFilters.utils = {
    initSampleCanvas: function () {
        var _canvas = document.createElement('canvas'),
            _context = _canvas.getContext('2d');

        _canvas.width = 0;
        _canvas.height = 0;

        this.getSampleCanvas = function () {
            return _canvas;
        };
        this.getSampleContext = function () {
            return _context;
        };
        this.createImageData = (_context.createImageData) ? function (w, h) {
            return _context.createImageData(w, h);
        } : function (w, h) {
            return new ImageData(w, h);
        };
    },
    getSampleCanvas: function () {
        this.initSampleCanvas();
        return this.getSampleCanvas();
    },
    getSampleContext: function () {
        this.initSampleCanvas();
        return this.getSampleContext();
    },
    createImageData: function (w, h) {
        this.initSampleCanvas();
        return this.createImageData(w, h);
    },
    clamp: function (value) {
        return value > 255 ? 255 : value < 0 ? 0 : value;
    },
    buildMap: function (f) {
        for (var m = [], k = 0, v; k < 256; k += 1) {
            m[k] = (v = f(k)) > 255 ? 255 : v < 0 ? 0 : v | 0;
        }
        return m;
    },
    applyMap: function (src, dst, map) {
        for (var i = 0, l = src.length; i < l; i += 4) {
            dst[i] = map[src[i]];
            dst[i + 1] = map[src[i + 1]];
            dst[i + 2] = map[src[i + 2]];
            dst[i + 3] = src[i + 3];
        }
    },
    mapRGB: function (src, dst, func) {
        this.applyMap(src, dst, this.buildMap(func));
    },
    getPixelIndex: function (x, y, width, height, edge) {
        if (x < 0 || x >= width || y < 0 || y >= height) {
            switch (edge) {
                case 1: // clamp
                    x = x < 0 ? 0 : x >= width ? width - 1 : x;
                    y = y < 0 ? 0 : y >= height ? height - 1 : y;
                    break;
                case 2: // wrap
                    x = (x %= width) < 0 ? x + width : x;
                    y = (y %= height) < 0 ? y + height : y;
                    break;
                default: // transparent
                    return null;
            }
        }
        return (y * width + x) << 2;
    },
    getPixel: function (src, x, y, width, height, edge) {
        if (x < 0 || x >= width || y < 0 || y >= height) {
            switch (edge) {
                case 1: // clamp
                    x = x < 0 ? 0 : x >= width ? width - 1 : x;
                    y = y < 0 ? 0 : y >= height ? height - 1 : y;
                    break;
                case 2: // wrap
                    x = (x %= width) < 0 ? x + width : x;
                    y = (y %= height) < 0 ? y + height : y;
                    break;
                default: // transparent
                    return 0;
            }
        }

        var i = (y * width + x) << 2;

        // ARGB
        return src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];
    },
    getPixelByIndex: function (src, i) {
        return src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];
    },
    /**
     * one of the most important functions in this library.
     * I want to make this as fast as possible.
     */
    copyBilinear: function (src, x, y, width, height, dst, dstIndex, edge) {
        var fx = x < 0 ? x - 1 | 0 : x | 0, // Math.floor(x)
            fy = y < 0 ? y - 1 | 0 : y | 0, // Math.floor(y)
            wx = x - fx,
            wy = y - fy,
            i,
            nw = 0, ne = 0, sw = 0, se = 0,
            cx, cy,
            r, g, b, a;

        if (fx >= 0 && fx < (width - 1) && fy >= 0 && fy < (height - 1)) {
            // in bounds, no edge actions required
            i = (fy * width + fx) << 2;

            if (wx || wy) {
                nw = src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];

                i += 4;
                ne = src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];

                i = (i - 8) + (width << 2);
                sw = src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];

                i += 4;
                se = src[i + 3] << 24 | src[i] << 16 | src[i + 1] << 8 | src[i + 2];
            }
            else {
                // no interpolation required
                dst[dstIndex] = src[i];
                dst[dstIndex + 1] = src[i + 1];
                dst[dstIndex + 2] = src[i + 2];
                dst[dstIndex + 3] = src[i + 3];
                return;
            }
        }
        else {
            // edge actions required
            nw = this.getPixel(src, fx, fy, width, height, edge);

            if (wx || wy) {
                ne = this.getPixel(src, fx + 1, fy, width, height, edge);
                sw = this.getPixel(src, fx, fy + 1, width, height, edge);
                se = this.getPixel(src, fx + 1, fy + 1, width, height, edge);
            }
            else {
                // no interpolation required
                dst[dstIndex] = nw >> 16 & 0xFF;
                dst[dstIndex + 1] = nw >> 8 & 0xFF;
                dst[dstIndex + 2] = nw & 0xFF;
                dst[dstIndex + 3] = nw >> 24 & 0xFF;
                return;
            }
        }

        cx = 1 - wx;
        cy = 1 - wy;
        r = ((nw >> 16 & 0xFF) * cx + (ne >> 16 & 0xFF) * wx) * cy + ((sw >> 16 & 0xFF) * cx + (se >> 16 & 0xFF) * wx) * wy;
        g = ((nw >> 8 & 0xFF) * cx + (ne >> 8 & 0xFF) * wx) * cy + ((sw >> 8 & 0xFF) * cx + (se >> 8 & 0xFF) * wx) * wy;
        b = ((nw & 0xFF) * cx + (ne & 0xFF) * wx) * cy + ((sw & 0xFF) * cx + (se & 0xFF) * wx) * wy;
        a = ((nw >> 24 & 0xFF) * cx + (ne >> 24 & 0xFF) * wx) * cy + ((sw >> 24 & 0xFF) * cx + (se >> 24 & 0xFF) * wx) * wy;

        dst[dstIndex] = r > 255 ? 255 : r < 0 ? 0 : r | 0;
        dst[dstIndex + 1] = g > 255 ? 255 : g < 0 ? 0 : g | 0;
        dst[dstIndex + 2] = b > 255 ? 255 : b < 0 ? 0 : b | 0;
        dst[dstIndex + 3] = a > 255 ? 255 : a < 0 ? 0 : a | 0;
    },
    /**
     * @param r 0 <= n <= 255
     * @param g 0 <= n <= 255
     * @param b 0 <= n <= 255
     * @return Array(h, s, l)
     */
    rgbToHsl: function (r, g, b) {
        r /= 255;
        g /= 255;
        b /= 255;

        //        var max = Math.max(r, g, b),
        //            min = Math.min(r, g, b),
        var max = (r > g) ? (r > b) ? r : b : (g > b) ? g : b,
            min = (r < g) ? (r < b) ? r : b : (g < b) ? g : b,
            chroma = max - min,
            h = 0,
            s = 0,
            // Lightness
            l = (min + max) / 2;

        if (chroma !== 0) {
            // Hue
            if (r === max) {
                h = (g - b) / chroma + ((g < b) ? 6 : 0);
            }
            else if (g === max) {
                h = (b - r) / chroma + 2;
            }
            else {
                h = (r - g) / chroma + 4;
            }
            h /= 6;

            // Saturation
            s = (l > 0.5) ? chroma / (2 - max - min) : chroma / (max + min);
        }

        return [h, s, l];
    },
    /**
     * @param h 0.0 <= n <= 1.0
     * @param s 0.0 <= n <= 1.0
     * @param l 0.0 <= n <= 1.0
     * @return Array(r, g, b)
     */
    hslToRgb: function (h, s, l) {
        var m1, m2, hue,
            r, g, b,
            rgb = [];

        if (s === 0) {
            r = g = b = l * 255 + 0.5 | 0;
            rgb = [r, g, b];
        }
        else {
            if (l <= 0.5) {
                m2 = l * (s + 1);
            }
            else {
                m2 = l + s - l * s;
            }

            m1 = l * 2 - m2;
            hue = h + 1 / 3;

            var tmp;
            for (var i = 0; i < 3; i += 1) {
                if (hue < 0) {
                    hue += 1;
                }
                else if (hue > 1) {
                    hue -= 1;
                }

                if (6 * hue < 1) {
                    tmp = m1 + (m2 - m1) * hue * 6;
                }
                else if (2 * hue < 1) {
                    tmp = m2;
                }
                else if (3 * hue < 2) {
                    tmp = m1 + (m2 - m1) * (2 / 3 - hue) * 6;
                }
                else {
                    tmp = m1;
                }

                rgb[i] = tmp * 255 + 0.5 | 0;

                hue -= 1 / 3;
            }
        }

        return rgb;
    }
};


// TODO
ImageFilters.Translate = function (srcImageData, x, y, interpolation) {

};
ImageFilters.Scale = function (srcImageData, scaleX, scaleY, interpolation) {

};
ImageFilters.Rotate = function (srcImageData, originX, originY, angle, resize, interpolation) {

};
ImageFilters.Affine = function (srcImageData, matrix, resize, interpolation) {

};
ImageFilters.UnsharpMask = function (srcImageData, level) {

};

ImageFilters.ConvolutionFilter = function (srcImageData, matrixX, matrixY, matrix, divisor, bias, preserveAlpha, clamp, color, alpha) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    divisor = divisor || 1;
    bias = bias || 0;

    // default true
    (preserveAlpha !== false) && (preserveAlpha = true);
    (clamp !== false) && (clamp = true);

    color = color || 0;
    alpha = alpha || 0;

    var index = 0,
        rows = matrixX >> 1,
        cols = matrixY >> 1,
        clampR = color >> 16 & 0xFF,
        clampG = color >> 8 & 0xFF,
        clampB = color & 0xFF,
        clampA = alpha * 0xFF;

    for (var y = 0; y < srcHeight; y += 1) {
        for (var x = 0; x < srcWidth; x += 1, index += 4) {
            var r = 0,
                g = 0,
                b = 0,
                a = 0,
                replace = false,
                mIndex = 0,
                v;

            for (var row = -rows; row <= rows; row += 1) {
                var rowIndex = y + row,
                    offset;

                if (0 <= rowIndex && rowIndex < srcHeight) {
                    offset = rowIndex * srcWidth;
                }
                else if (clamp) {
                    offset = y * srcWidth;
                }
                else {
                    replace = true;
                }

                for (var col = -cols; col <= cols; col += 1) {
                    var m = matrix[mIndex++];

                    if (m !== 0) {
                        var colIndex = x + col;

                        if (!(0 <= colIndex && colIndex < srcWidth)) {
                            if (clamp) {
                                colIndex = x;
                            }
                            else {
                                replace = true;
                            }
                        }

                        if (replace) {
                            r += m * clampR;
                            g += m * clampG;
                            b += m * clampB;
                            a += m * clampA;
                        }
                        else {
                            var p = (offset + colIndex) << 2;
                            r += m * srcPixels[p];
                            g += m * srcPixels[p + 1];
                            b += m * srcPixels[p + 2];
                            a += m * srcPixels[p + 3];
                        }
                    }
                }
            }

            dstPixels[index] = (v = r / divisor + bias) > 255 ? 255 : v < 0 ? 0 : v | 0;
            dstPixels[index + 1] = (v = g / divisor + bias) > 255 ? 255 : v < 0 ? 0 : v | 0;
            dstPixels[index + 2] = (v = b / divisor + bias) > 255 ? 255 : v < 0 ? 0 : v | 0;
            dstPixels[index + 3] = preserveAlpha ? srcPixels[index + 3] : (v = a / divisor + bias) > 255 ? 255 : v < 0 ? 0 : v | 0;
        }
    }

    return dstImageData;
};

ImageFilters.Mosaic = function (srcImageData, blockSize) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var cols = Math.ceil(srcWidth / blockSize),
        rows = Math.ceil(srcHeight / blockSize),
        row, col,
        x_start, x_end, y_start, y_end,
        x, y, yIndex, index, size,
        r, g, b, a;

    for (row = 0; row < rows; row += 1) {
        y_start = row * blockSize;
        y_end = y_start + blockSize;

        if (y_end > srcHeight) {
            y_end = srcHeight;
        }

        for (col = 0; col < cols; col += 1) {
            x_start = col * blockSize;
            x_end = x_start + blockSize;

            if (x_end > srcWidth) {
                x_end = srcWidth;
            }

            // get the average color from the src
            r = g = b = a = 0;
            size = (x_end - x_start) * (y_end - y_start);

            for (y = y_start; y < y_end; y += 1) {
                yIndex = y * srcWidth;

                for (x = x_start; x < x_end; x += 1) {
                    index = (yIndex + x) << 2;
                    r += srcPixels[index];
                    g += srcPixels[index + 1];
                    b += srcPixels[index + 2];
                    a += srcPixels[index + 3];
                }
            }

            r = (r / size) + 0.5 | 0;
            g = (g / size) + 0.5 | 0;
            b = (b / size) + 0.5 | 0;
            a = (a / size) + 0.5 | 0;

            // fill the dst with that color
            for (y = y_start; y < y_end; y += 1) {
                yIndex = y * srcWidth;

                for (x = x_start; x < x_end; x += 1) {
                    index = (yIndex + x) << 2;
                    dstPixels[index] = r;
                    dstPixels[index + 1] = g;
                    dstPixels[index + 2] = b;
                    dstPixels[index + 3] = a;
                }
            }
        }
    }

    return dstImageData;
};


/**
 * @param threshold 0.0 <= n <= 1.0
 */
ImageFilters.Binarize = function (srcImageData, threshold) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    if (isNaN(threshold)) {
        threshold = 0.5;
    }

    threshold *= 255;

    for (var i = 0; i < srcLength; i += 4) {
        var avg = srcPixels[i] + srcPixels[i + 1] + srcPixels[i + 2] / 3;

        dstPixels[i] = dstPixels[i + 1] = dstPixels[i + 2] = avg <= threshold ? 0 : 255;
        dstPixels[i + 3] = 255;
    }

    return dstImageData;
};

ImageFilters.BlendAdd = function (srcImageData, blendImageData, dx, dy) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data,
        blendPixels = blendImageData.data;

    var v;

    for (var i = 0; i < srcLength; i += 4) {
        dstPixels[i] = ((v = srcPixels[i] + blendPixels[i]) > 255) ? 255 : v;
        dstPixels[i + 1] = ((v = srcPixels[i + 1] + blendPixels[i + 1]) > 255) ? 255 : v;
        dstPixels[i + 2] = ((v = srcPixels[i + 2] + blendPixels[i + 2]) > 255) ? 255 : v;
        dstPixels[i + 3] = 255;
    }

    return dstImageData;
};

ImageFilters.BlendSubtract = function (srcImageData, blendImageData, dx, dy) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data,
        blendPixels = blendImageData.data;

    var v;

    for (var i = 0; i < srcLength; i += 4) {
        dstPixels[i] = ((v = srcPixels[i] - blendPixels[i]) < 0) ? 0 : v;
        dstPixels[i + 1] = ((v = srcPixels[i + 1] - blendPixels[i + 1]) < 0) ? 0 : v;
        dstPixels[i + 2] = ((v = srcPixels[i + 2] - blendPixels[i + 2]) < 0) ? 0 : v;
        dstPixels[i + 3] = 255;
    }

    return dstImageData;
};
;

ImageFilters.Channels = function (srcImageData, channel) {
    var matrix;

    switch (channel) {
        case 2: // green
            matrix = [
                0, 1, 0, 0, 0,
                0, 1, 0, 0, 0,
                0, 1, 0, 0, 0,
                0, 0, 0, 1, 0
            ];
            break;
        case 3: // blue
            matrix = [
                0, 0, 1, 0, 0,
                0, 0, 1, 0, 0,
                0, 0, 1, 0, 0,
                0, 0, 0, 1, 0
            ];
            break;
        default: // red
            matrix = [
                1, 0, 0, 0, 0,
                1, 0, 0, 0, 0,
                1, 0, 0, 0, 0,
                0, 0, 0, 1, 0
            ];
            break;

    }

    return this.ColorMatrixFilter(srcImageData, matrix);
};

ImageFilters.Clone = function (srcImageData) {
    return this.Copy(srcImageData, this.utils.createImageData(srcImageData.width, srcImageData.height));
};

/**
 * slower
 */
ImageFilters.CloneBuiltin = function (srcImageData) {
    var srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        canvas = this.utils.getSampleCanvas(),
        context = this.utils.getSampleContext(),
        dstImageData;

    canvas.width = srcWidth;
    canvas.height = srcHeight;

    context.putImageData(srcImageData, 0, 0);
    dstImageData = context.getImageData(0, 0, srcWidth, srcHeight);

    canvas.width = 0;
    canvas.height = 0;

    return dstImageData;
};

ImageFilters.ColorMatrixFilter = function (srcImageData, matrix) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var m0 = matrix[0],
        m1 = matrix[1],
        m2 = matrix[2],
        m3 = matrix[3],
        m4 = matrix[4],
        m5 = matrix[5],
        m6 = matrix[6],
        m7 = matrix[7],
        m8 = matrix[8],
        m9 = matrix[9],
        m10 = matrix[10],
        m11 = matrix[11],
        m12 = matrix[12],
        m13 = matrix[13],
        m14 = matrix[14],
        m15 = matrix[15],
        m16 = matrix[16],
        m17 = matrix[17],
        m18 = matrix[18],
        m19 = matrix[19];

    var value, i, r, g, b, a;
    for (i = 0; i < srcLength; i += 4) {
        r = srcPixels[i];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];

        dstPixels[i] = (value = r * m0 + g * m1 + b * m2 + a * m3 + m4) > 255 ? 255 : value < 0 ? 0 : value | 0;
        dstPixels[i + 1] = (value = r * m5 + g * m6 + b * m7 + a * m8 + m9) > 255 ? 255 : value < 0 ? 0 : value | 0;
        dstPixels[i + 2] = (value = r * m10 + g * m11 + b * m12 + a * m13 + m14) > 255 ? 255 : value < 0 ? 0 : value | 0;
        dstPixels[i + 3] = (value = r * m15 + g * m16 + b * m17 + a * m18 + m19) > 255 ? 255 : value < 0 ? 0 : value | 0;
    }

    return dstImageData;
};

ImageFilters.ColorTransformFilter = function (
    srcImageData, redMultiplier, greenMultiplier, blueMultiplier, alphaMultiplier,
    redOffset, greenOffset, blueOffset, alphaOffset) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var i, v;
    for (i = 0; i < srcLength; i += 4) {
        dstPixels[i] = (v = srcPixels[i] * redMultiplier + redOffset) > 255 ? 255 : v < 0 ? 0 : v;
        dstPixels[i + 1] = (v = srcPixels[i + 1] * greenMultiplier + greenOffset) > 255 ? 255 : v < 0 ? 0 : v;
        dstPixels[i + 2] = (v = srcPixels[i + 2] * blueMultiplier + blueOffset) > 255 ? 255 : v < 0 ? 0 : v;
        dstPixels[i + 3] = (v = srcPixels[i + 3] * alphaMultiplier + alphaOffset) > 255 ? 255 : v < 0 ? 0 : v;
    }

    return dstImageData;
};

ImageFilters.Copy = function (srcImageData, dstImageData) {
    var srcPixels = srcImageData.data,
        srcLength = srcPixels.length,
        dstPixels = dstImageData.data;

    while (srcLength--) {
        dstPixels[srcLength] = srcPixels[srcLength];
    }

    return dstImageData;
};

ImageFilters.Crop = function (srcImageData, x, y, width, height) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(width, height),
        dstPixels = dstImageData.data;

    var srcLeft = Math.max(x, 0),
        srcTop = Math.max(y, 0),
        srcRight = Math.min(x + width, srcWidth),
        srcBottom = Math.min(y + height, srcHeight),
        dstLeft = srcLeft - x,
        dstTop = srcTop - y,
        srcRow, srcCol, srcIndex, dstIndex;

    for (var srcRow = srcTop, dstRow = dstTop; srcRow < srcBottom; srcRow += 1, dstRow += 1) {
        for (var srcCol = srcLeft, dstCol = dstLeft; srcCol < srcRight; srcCol += 1, dstCol += 1) {
            srcIndex = (srcRow * srcWidth + srcCol) << 2;
            dstIndex = (dstRow * width + dstCol) << 2;
            dstPixels[dstIndex] = srcPixels[srcIndex];
            dstPixels[dstIndex + 1] = srcPixels[srcIndex + 1];
            dstPixels[dstIndex + 2] = srcPixels[srcIndex + 2];
            dstPixels[dstIndex + 3] = srcPixels[srcIndex + 3];
        }
    }

    return dstImageData;
};

ImageFilters.CropBuiltin = function (srcImageData, x, y, width, height) {
    var srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        canvas = this.utils.getSampleCanvas(),
        context = this.utils.getSampleContext();

    canvas.width = srcWidth;
    canvas.height = srcHeight;
    context.putImageData(srcImageData, 0, 0);
    var result = context.getImageData(x, y, width, height);

    canvas.width = 0;
    canvas.height = 0;

    return result;
};

/**
 * sets to the average of the highest and lowest contrast
 */
ImageFilters.Desaturate = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    for (var i = 0; i < srcLength; i += 4) {
        var r = srcPixels[i],
            g = srcPixels[i + 1],
            b = srcPixels[i + 2],
            max = (r > g) ? (r > b) ? r : b : (g > b) ? g : b,
            min = (r < g) ? (r < b) ? r : b : (g < b) ? g : b,
            avg = ((max + min) / 2) + 0.5 | 0;

        dstPixels[i] = dstPixels[i + 1] = dstPixels[i + 2] = avg;
        dstPixels[i + 3] = srcPixels[i + 3];
    }

    return dstImageData;
};

/**
 * TODO: use bilinear
 */
ImageFilters.DisplacementMapFilter = function (srcImageData, mapImageData, mapX, mapY, componentX, componentY, scaleX, scaleY, mode) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        //        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstImageData = ImageFilters.Clone(srcImageData),
        dstPixels = dstImageData.data;

    mapX || (mapX = 0);
    mapY || (mapY = 0);
    componentX || (componentX = 0); // red?
    componentY || (componentY = 0);
    scaleX || (scaleX = 0);
    scaleY || (scaleY = 0);
    mode || (mode = 2); // wrap

    var mapWidth = mapImageData.width,
        mapHeight = mapImageData.height,
        mapPixels = mapImageData.data,
        mapRight = mapWidth + mapX,
        mapBottom = mapHeight + mapY,
        dstIndex, srcIndex, mapIndex,
        cx, cy, tx, ty, x, y;

    for (x = 0; x < srcWidth; x += 1) {
        for (y = 0; y < srcHeight; y += 1) {

            dstIndex = (y * srcWidth + x) << 2;

            if (x < mapX || y < mapY || x >= mapRight || y >= mapBottom) {
                // out of the map bounds
                // copy src to dst
                srcIndex = dstIndex;
            } else {
                // apply map
                mapIndex = ((y - mapY) * mapWidth + (x - mapX)) << 2;

                // tx = x + ((componentX(x, y) - 128) * scaleX) / 256
                cx = mapPixels[mapIndex + componentX];
                tx = x + (((cx - 128) * scaleX) >> 8);

                // tx = y + ((componentY(x, y) - 128) * scaleY) / 256
                cy = mapPixels[mapIndex + componentY];
                ty = y + (((cy - 128) * scaleY) >> 8);

                srcIndex = ImageFilters.utils.getPixelIndex(tx + 0.5 | 0, ty + 0.5 | 0, srcWidth, srcHeight, mode);
                if (srcIndex === null) {
                    // if mode == ignore and (tx,ty) is out of src bounds
                    // then copy (x,y) to dst
                    srcIndex = dstIndex;
                }
            }

            dstPixels[dstIndex] = srcPixels[srcIndex];
            dstPixels[dstIndex + 1] = srcPixels[srcIndex + 1];
            dstPixels[dstIndex + 2] = srcPixels[srcIndex + 2];
            dstPixels[dstIndex + 3] = srcPixels[srcIndex + 3];
        }
    }

    return dstImageData;
};

/**
 * Floyd-Steinberg algorithm
 * @param levels 2 <= n <= 255
 */
ImageFilters.Dither = function (srcImageData, levels) {
    var srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        dstImageData = this.Clone(srcImageData),
        dstPixels = dstImageData.data;

    levels = levels < 2 ? 2 : levels > 255 ? 255 : levels;

    // Build a color map using the same algorithm as the posterize filter.
    var posterize,
        levelMap = [],
        levelsMinus1 = levels - 1,
        j = 0,
        k = 0,
        i;

    for (i = 0; i < levels; i += 1) {
        levelMap[i] = (255 * i) / levelsMinus1;
    }

    posterize = this.utils.buildMap(function (value) {
        var ret = levelMap[j];

        k += levels;

        if (k > 255) {
            k -= 255;
            j += 1;
        }

        return ret;
    });

    // Apply the dithering algorithm to each pixel
    var x, y,
        index,
        old_r, old_g, old_b,
        new_r, new_g, new_b,
        err_r, err_g, err_b,
        nbr_r, nbr_g, nbr_b,
        srcWidthMinus1 = srcWidth - 1,
        srcHeightMinus1 = srcHeight - 1,
        A = 7 / 16,
        B = 3 / 16,
        C = 5 / 16,
        D = 1 / 16;

    for (y = 0; y < srcHeight; y += 1) {
        for (x = 0; x < srcWidth; x += 1) {
            // Get the current pixel.
            index = (y * srcWidth + x) << 2;

            old_r = dstPixels[index];
            old_g = dstPixels[index + 1];
            old_b = dstPixels[index + 2];

            // Quantize using the color map
            new_r = posterize[old_r];
            new_g = posterize[old_g];
            new_b = posterize[old_b];

            // Set the current pixel.
            dstPixels[index] = new_r;
            dstPixels[index + 1] = new_g;
            dstPixels[index + 2] = new_b;

            // Quantization errors
            err_r = old_r - new_r;
            err_g = old_g - new_g;
            err_b = old_b - new_b;

            // Apply the matrix.
            // x + 1, y
            index += 1 << 2;
            if (x < srcWidthMinus1) {
                nbr_r = dstPixels[index] + A * err_r;
                nbr_g = dstPixels[index + 1] + A * err_g;
                nbr_b = dstPixels[index + 2] + A * err_b;

                dstPixels[index] = nbr_r > 255 ? 255 : nbr_r < 0 ? 0 : nbr_r | 0;
                dstPixels[index + 1] = nbr_g > 255 ? 255 : nbr_g < 0 ? 0 : nbr_g | 0;
                dstPixels[index + 2] = nbr_b > 255 ? 255 : nbr_b < 0 ? 0 : nbr_b | 0;
            }

            // x - 1, y + 1
            index += (srcWidth - 2) << 2;
            if (x > 0 && y < srcHeightMinus1) {
                nbr_r = dstPixels[index] + B * err_r;
                nbr_g = dstPixels[index + 1] + B * err_g;
                nbr_b = dstPixels[index + 2] + B * err_b;

                dstPixels[index] = nbr_r > 255 ? 255 : nbr_r < 0 ? 0 : nbr_r | 0;
                dstPixels[index + 1] = nbr_g > 255 ? 255 : nbr_g < 0 ? 0 : nbr_g | 0;
                dstPixels[index + 2] = nbr_b > 255 ? 255 : nbr_b < 0 ? 0 : nbr_b | 0;
            }

            // x, y + 1
            index += 1 << 2;
            if (y < srcHeightMinus1) {
                nbr_r = dstPixels[index] + C * err_r;
                nbr_g = dstPixels[index + 1] + C * err_g;
                nbr_b = dstPixels[index + 2] + C * err_b;

                dstPixels[index] = nbr_r > 255 ? 255 : nbr_r < 0 ? 0 : nbr_r | 0;
                dstPixels[index + 1] = nbr_g > 255 ? 255 : nbr_g < 0 ? 0 : nbr_g | 0;
                dstPixels[index + 2] = nbr_b > 255 ? 255 : nbr_b < 0 ? 0 : nbr_b | 0;
            }

            // x + 1, y + 1
            index += 1 << 2;
            if (x < srcWidthMinus1 && y < srcHeightMinus1) {
                nbr_r = dstPixels[index] + D * err_r;
                nbr_g = dstPixels[index + 1] + D * err_g;
                nbr_b = dstPixels[index + 2] + D * err_b;

                dstPixels[index] = nbr_r > 255 ? 255 : nbr_r < 0 ? 0 : nbr_r | 0;
                dstPixels[index + 1] = nbr_g > 255 ? 255 : nbr_g < 0 ? 0 : nbr_g | 0;
                dstPixels[index + 2] = nbr_b > 255 ? 255 : nbr_b < 0 ? 0 : nbr_b | 0;
            }
        }
    }

    return dstImageData;
};

ImageFilters.Edge = function (srcImageData) {
    //pretty close to Fireworks 'Find Edges' effect
    return this.ConvolutionFilter(srcImageData, 3, 3, [
        -1, -1, -1,
        -1, 8, -1,
        -1, -1, -1
    ]);
};

ImageFilters.Emboss = function (srcImageData) {
    return this.ConvolutionFilter(srcImageData, 3, 3, [
        -2, -1, 0,
        -1, 1, 1,
        0, 1, 2
    ]);
};

ImageFilters.Enrich = function (srcImageData) {
    return this.ConvolutionFilter(srcImageData, 3, 3, [
        0, -2, 0,
        -2, 20, -2,
        0, -2, 0
    ], 10, -40);
};

ImageFilters.Flip = function (srcImageData, vertical) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var x, y, srcIndex, dstIndex, i;

    for (y = 0; y < srcHeight; y += 1) {
        for (x = 0; x < srcWidth; x += 1) {
            srcIndex = (y * srcWidth + x) << 2;
            if (vertical) {
                dstIndex = ((srcHeight - y - 1) * srcWidth + x) << 2;
            }
            else {
                dstIndex = (y * srcWidth + (srcWidth - x - 1)) << 2;
            }

            dstPixels[dstIndex] = srcPixels[srcIndex];
            dstPixels[dstIndex + 1] = srcPixels[srcIndex + 1];
            dstPixels[dstIndex + 2] = srcPixels[srcIndex + 2];
            dstPixels[dstIndex + 3] = srcPixels[srcIndex + 3];
        }
    }

    return dstImageData;
};

ImageFilters.Gamma = function (srcImageData, gamma) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    this.utils.mapRGB(srcPixels, dstPixels, function (value) {
        value = (255 * Math.pow(value / 255, 1 / gamma) + 0.5);
        return value > 255 ? 255 : value + 0.5 | 0;
    });

    return dstImageData;
};

ImageFilters.GrayScale = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    for (var i = 0; i < srcLength; i += 4) {
        var intensity = (srcPixels[i] * 19595 + srcPixels[i + 1] * 38470 + srcPixels[i + 2] * 7471) >> 16;
        //var intensity = (srcPixels[i] * 0.3086 + srcPixels[i + 1] * 0.6094 + srcPixels[i + 2] * 0.0820) | 0;
        dstPixels[i] = dstPixels[i + 1] = dstPixels[i + 2] = intensity;
        dstPixels[i + 3] = srcPixels[i + 3];
    }

    return dstImageData;
};

/**
 * @param hueDelta  -180 <= n <= 180
 * @param satDelta  -100 <= n <= 100
 * @param lightness -100 <= n <= 100
 */
ImageFilters.HSLAdjustment = function (srcImageData, hueDelta, satDelta, lightness) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    hueDelta /= 360;
    satDelta /= 100;
    lightness /= 100;

    var rgbToHsl = this.utils.rgbToHsl;
    var hslToRgb = this.utils.hslToRgb;
    var h, s, l, hsl, rgb, i;

    for (i = 0; i < srcLength; i += 4) {
        // convert to HSL
        hsl = rgbToHsl(srcPixels[i], srcPixels[i + 1], srcPixels[i + 2]);

        // hue
        h = hsl[0] + hueDelta;
        while (h < 0) {
            h += 1;
        }
        while (h > 1) {
            h -= 1;
        }

        // saturation
        s = hsl[1] + hsl[1] * satDelta;
        if (s < 0) {
            s = 0;
        }
        else if (s > 1) {
            s = 1;
        }

        // lightness
        l = hsl[2];
        if (lightness > 0) {
            l += (1 - l) * lightness;
        }
        else if (lightness < 0) {
            l += l * lightness;
        }

        // convert back to rgb
        rgb = hslToRgb(h, s, l);

        dstPixels[i] = rgb[0];
        dstPixels[i + 1] = rgb[1];
        dstPixels[i + 2] = rgb[2];
        dstPixels[i + 3] = srcPixels[i + 3];
    }

    return dstImageData;
};

ImageFilters.Invert = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    this.utils.mapRGB(srcPixels, dstPixels, function (value) {
        return 255 - value;
    });

    return dstImageData;
};


/**
 * @param range  1 <= n <= 5
 * @param levels 1 <= n <= 256
 */
ImageFilters.Oil = function (srcImageData, range, levels) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var index = 0,
        rh = [],
        gh = [],
        bh = [],
        rt = [],
        gt = [],
        bt = [],
        x, y, i, row, col,
        rowIndex, colIndex, offset, srcIndex,
        sr, sg, sb, ri, gi, bi,
        r, g, b;

    for (y = 0; y < srcHeight; y += 1) {
        for (x = 0; x < srcWidth; x += 1) {
            for (i = 0; i < levels; i += 1) {
                rh[i] = gh[i] = bh[i] = rt[i] = gt[i] = bt[i] = 0;
            }

            for (row = -range; row <= range; row += 1) {
                rowIndex = y + row;

                if (rowIndex < 0 || rowIndex >= srcHeight) {
                    continue;
                }

                offset = rowIndex * srcWidth;

                for (col = -range; col <= range; col += 1) {
                    colIndex = x + col;
                    if (colIndex < 0 || colIndex >= srcWidth) {
                        continue;
                    }

                    srcIndex = (offset + colIndex) << 2;
                    sr = srcPixels[srcIndex];
                    sg = srcPixels[srcIndex + 1];
                    sb = srcPixels[srcIndex + 2];
                    ri = (sr * levels) >> 8;
                    gi = (sg * levels) >> 8;
                    bi = (sb * levels) >> 8;
                    rt[ri] += sr;
                    gt[gi] += sg;
                    bt[bi] += sb;
                    rh[ri] += 1;
                    gh[gi] += 1;
                    bh[bi] += 1;
                }
            }

            r = g = b = 0;
            for (i = 1; i < levels; i += 1) {
                if (rh[i] > rh[r]) {
                    r = i;
                }
                if (gh[i] > gh[g]) {
                    g = i;
                }
                if (bh[i] > bh[b]) {
                    b = i;
                }
            }

            dstPixels[index] = rt[r] / rh[r] | 0;
            dstPixels[index + 1] = gt[g] / gh[g] | 0;
            dstPixels[index + 2] = bt[b] / bh[b] | 0;
            dstPixels[index + 3] = srcPixels[index + 3];
            index += 4;
        }
    }

    return dstImageData;
};

ImageFilters.OpacityFilter = function (srcImageData, opacity) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    for (var i = 0; i < srcLength; i += 4) {
        dstPixels[i] = srcPixels[i];
        dstPixels[i + 1] = srcPixels[i + 1];
        dstPixels[i + 2] = srcPixels[i + 2];
        dstPixels[i + 3] = opacity;
    }

    return dstImageData;
};

/**
 * @param levels 2 <= n <= 255
 */
ImageFilters.Posterize = function (srcImageData, levels) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    levels = levels < 2 ? 2 : levels > 255 ? 255 : levels;

    var levelMap = [],
        levelsMinus1 = levels - 1,
        j = 0,
        k = 0,
        i;

    for (i = 0; i < levels; i += 1) {
        levelMap[i] = (255 * i) / levelsMinus1;
    }

    this.utils.mapRGB(srcPixels, dstPixels, function (value) {
        var ret = levelMap[j];

        k += levels;

        if (k > 255) {
            k -= 255;
            j += 1;
        }

        return ret;
    });

    return dstImageData;
};

/**
 * @param scale 0.0 <= n <= 5.0
 */
ImageFilters.Rescale = function (srcImageData, scale) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    this.utils.mapRGB(srcPixels, dstPixels, function (value) {
        value *= scale;
        return (value > 255) ? 255 : value + 0.5 | 0;
    });

    return dstImageData;
};

/**
 * Nearest neighbor
 */
ImageFilters.ResizeNearestNeighbor = function (srcImageData, width, height) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(width, height),
        dstPixels = dstImageData.data;

    var xFactor = srcWidth / width,
        yFactor = srcHeight / height,
        dstIndex = 0, srcIndex,
        x, y, offset;

    for (y = 0; y < height; y += 1) {
        offset = ((y * yFactor) | 0) * srcWidth;

        for (x = 0; x < width; x += 1) {
            srcIndex = (offset + x * xFactor) << 2;

            dstPixels[dstIndex] = srcPixels[srcIndex];
            dstPixels[dstIndex + 1] = srcPixels[srcIndex + 1];
            dstPixels[dstIndex + 2] = srcPixels[srcIndex + 2];
            dstPixels[dstIndex + 3] = srcPixels[srcIndex + 3];
            dstIndex += 4;
        }
    }

    return dstImageData;
};

/**
 * Bilinear
 */
ImageFilters.Resize = function (srcImageData, width, height) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(width, height),
        dstPixels = dstImageData.data;

    var xFactor = srcWidth / width,
        yFactor = srcHeight / height,
        dstIndex = 0,
        x, y;

    for (y = 0; y < height; y += 1) {
        for (x = 0; x < width; x += 1) {
            this.utils.copyBilinear(srcPixels, x * xFactor, y * yFactor, srcWidth, srcHeight, dstPixels, dstIndex, 0);
            dstIndex += 4;
        }
    }

    return dstImageData;
};


/**
 * faster resizing using the builtin context.scale()
 * the resizing algorithm may be different between browsers
 * this might not work if the image is transparent.
 * to fix that we probably need two contexts
 */
ImageFilters.ResizeBuiltin = function (srcImageData, width, height) {
    var srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        canvas = this.utils.getSampleCanvas(),
        context = this.utils.getSampleContext(),
        dstImageData;

    canvas.width = Math.max(srcWidth, width);
    canvas.height = Math.max(srcHeight, height);
    context.save();

    context.putImageData(srcImageData, 0, 0);
    context.scale(width / srcWidth, height / srcHeight);
    context.drawImage(canvas, 0, 0);

    dstImageData = context.getImageData(0, 0, width, height);

    context.restore();
    canvas.width = 0;
    canvas.height = 0;

    return dstImageData;
};

ImageFilters.Sepia = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    var r, g, b, i, value;

    for (i = 0; i < srcLength; i += 4) {
        r = srcPixels[i];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];

        dstPixels[i] = (value = r * 0.393 + g * 0.769 + b * 0.189) > 255 ? 255 : value < 0 ? 0 : value + 0.5 | 0;
        dstPixels[i + 1] = (value = r * 0.349 + g * 0.686 + b * 0.168) > 255 ? 255 : value < 0 ? 0 : value + 0.5 | 0;
        dstPixels[i + 2] = (value = r * 0.272 + g * 0.534 + b * 0.131) > 255 ? 255 : value < 0 ? 0 : value + 0.5 | 0;
        dstPixels[i + 3] = srcPixels[i + 3];
    }

    return dstImageData;
};

/**
 * @param factor 1 <= n
 */
ImageFilters.Sharpen = function (srcImageData, factor) {
    //Convolution formula from VIGRA
    return this.ConvolutionFilter(srcImageData, 3, 3, [
        -factor / 16, -factor / 8, -factor / 16,
        -factor / 8, factor * 0.75 + 1, -factor / 8,
        -factor / 16, -factor / 8, -factor / 16
    ]);
};

ImageFilters.Solarize = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    this.utils.mapRGB(srcPixels, dstPixels, function (value) {
        return value > 127 ? (value - 127.5) * 2 : (127.5 - value) * 2;
    });

    return dstImageData;
};

ImageFilters.Transpose = function (srcImageData) {
    var srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcHeight, srcWidth),
        dstPixels = dstImageData.data;

    var srcIndex, dstIndex;

    for (var y = 0; y < srcHeight; y += 1) {
        for (var x = 0; x < srcWidth; x += 1) {
            srcIndex = (y * srcWidth + x) << 2;
            dstIndex = (x * srcHeight + y) << 2;

            dstPixels[dstIndex] = srcPixels[srcIndex];
            dstPixels[dstIndex + 1] = srcPixels[srcIndex + 1];
            dstPixels[dstIndex + 2] = srcPixels[srcIndex + 2];
            dstPixels[dstIndex + 3] = srcPixels[srcIndex + 3];
        }
    }

    return dstImageData;
};

function FilterUtils() {
    this.HSVtoRGB = function (h, s, v) {
        var r, g, b;
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);
        // eslint-disable-next-line default-case
        switch (i % 6) {
            // eslint-disable-next-line no-unused-expressions
            case 0: r = v, g = t, b = p; break;
            // eslint-disable-next-line no-unused-expressions
            case 1: r = q, g = v, b = p; break;
            // eslint-disable-next-line no-unused-expressions
            case 2: r = p, g = v, b = t; break;
            // eslint-disable-next-line no-unused-expressions
            case 3: r = p, g = q, b = v; break;
            // eslint-disable-next-line no-unused-expressions
            case 4: r = t, g = p, b = v; break;
            // eslint-disable-next-line no-unused-expressions
            case 5: r = v, g = p, b = q; break;
        }
        return [r * 255, g * 255, b * 255];
    }
    this.RGBtoHSV = function (r, g, b) {
        // eslint-disable-next-line no-unused-expressions
        r = r / 255, g = g / 255, b = b / 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max == 0 ? 0 : d / max;
        if (max == min) {
            h = 0;
        } else {
            switch (max) {
                // eslint-disable-next-line no-unused-expressions
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                // eslint-disable-next-line no-unused-expressions
                case g: h = (b - r) / d + 2; break;
                // eslint-disable-next-line no-unused-expressions
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return [h, s, v];
    }
    this.getPixel = function (pixels, x, y, width, height) {
        var pix = (y * width + x) * 4;
        if (x < 0 || x >= width || y < 0 || y >= height) {
            return [pixels[((this.clampPixel(y, 0, height - 1) * width) + this.clampPixel(x, 0, width - 1)) * 4],
            pixels[((this.clampPixel(y, 0, height - 1) * width) + this.clampPixel(x, 0, width - 1)) * 4 + 1],
            pixels[((this.clampPixel(y, 0, height - 1) * width) + this.clampPixel(x, 0, width - 1)) * 4 + 2],
            pixels[((this.clampPixel(y, 0, height - 1) * width) + this.clampPixel(x, 0, width - 1)) * 4 + 3]];
        }
        return [pixels[pix], pixels[pix + 1], pixels[pix + 2], pixels[pix + 3]]
    }
    var haveNextGaussian = false;
    var nextGaussian;
    this.gaussianRandom = function () {
        if (haveNextGaussian) {
            haveNextGaussian = false;
            return nextGaussian;
        } else {
            var v1, v2, s;
            do {
                v1 = 2 * Math.random() - 1;
                v2 = 2 * Math.random() - 1;
                s = v1 * v1 + v2 * v2;
            } while (s >= 1 || s == 0);
            var mult = Math.sqrt(-2 * Math.log(s) / s);
            nextGaussian = v2 * mult;
            haveNextGaussian = true;
            return v1 * mult;
        }
    }
    this.clampPixel = function (x, a, b) {
        return (x < a) ? a : (x > b) ? b : x;
    }
    this.triangle = function (x) {
        var r = this.mod(x, 1);
        return 2 * (r < 0.5 ? r : 1 - r);
    }
    this.mod = function (a, b) {
        var n = parseInt(a / b);
        a -= n * b;
        if (a < 0) {
            return a + b;
        }
        return a;
    }
    this.mixColors = function (t, rgb1, rgb2) {
        var r = this.linearInterpolate(t, rgb1[0], rgb2[0]);
        var g = this.linearInterpolate(t, rgb1[1], rgb2[1]);
        var b = this.linearInterpolate(t, rgb1[2], rgb2[2]);
        var a = this.linearInterpolate(t, rgb1[3], rgb2[3]);
        return [r, g, b, a];
    }

    this.linearInterpolate = function (t, a, b) {
        return a + t * (b - a);
    }
    this.bilinearInterpolate = function (x, y, nw, ne, sw, se) {
        var m0, m1;
        var r0 = nw[0]; var g0 = nw[1]; var b0 = nw[2]; var a0 = nw[3];
        var r1 = ne[0]; var g1 = ne[1]; var b1 = ne[2]; var a1 = ne[3];
        var r2 = sw[0]; var g2 = sw[1]; var b2 = sw[2]; var a2 = sw[3];
        var r3 = se[0]; var g3 = se[1]; var b3 = se[2]; var a3 = se[3];
        var cx = 1.0 - x; var cy = 1.0 - y;

        m0 = cx * a0 + x * a1;
        m1 = cx * a2 + x * a3;
        var a = cy * m0 + y * m1;

        m0 = cx * r0 + x * r1;
        m1 = cx * r2 + x * r3;
        var r = cy * m0 + y * m1;

        m0 = cx * g0 + x * g1;
        m1 = cx * g2 + x * g3;
        var g = cy * m0 + y * m1;

        m0 = cx * b0 + x * b1;
        m1 = cx * b2 + x * b3;
        var b = cy * m0 + y * m1;
        return [r, g, b, a];
    }
    this.tableFilter = function (inputData, table, width, height) {
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                for (var i = 0; i < 3; i++) {
                    inputData[pixel + i] = table[inputData[pixel + i]];
                }
            }
        }
    }
    this.convolveFilter = function (inputData, matrix, width, height) {
        var outputData = [];
        var rows, cols;
        rows = cols = Math.sqrt(matrix.length);
        var rows2 = parseInt(rows / 2);
        var cols2 = parseInt(cols / 2);
        var trace = true;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var r = 0, g = 0, b = 0;
                for (var row = -rows2; row <= rows2; row++) {
                    var iy = y + row;
                    var ioffset;
                    if (0 <= iy && iy < height) {
                        ioffset = iy * width;
                    } else {
                        ioffset = y * width;
                    }
                    var moffset = cols * (row + rows2) + cols2;
                    for (var col = -cols2; col <= cols2; col++) {
                        var f = matrix[moffset + col];

                        if (f != 0) {
                            var ix = x + col;
                            if (!(0 <= ix && ix < width)) {
                                ix = x;
                            }
                            var iPixel = (ioffset + ix) * 4;
                            r += f * inputData[iPixel];
                            g += f * inputData[iPixel + 1];
                            b += f * inputData[iPixel + 2];
                        }
                    }
                }
                outputData[pixel] = parseInt(r + 0.5);
                outputData[pixel + 1] = parseInt(g + 0.5);
                outputData[pixel + 2] = parseInt(b + 0.5);
                outputData[pixel + 3] = inputData[pixel + 3];
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
    this.transformFilter = function (inputData, transformInverse, width, height) {
        var out = [];
        var outputData = [];
        for (var j = 0; j < inputData.length; j++) {
            outputData[j] = inputData[j];
        }
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                transformInverse.apply(this, [x, y, out]);
                var srcX = Math.floor(out[0]);
                var srcY = Math.floor(out[1]);
                var xWeight = out[0] - srcX;
                var yWeight = out[1] - srcY;
                var nw, ne, sw, se;
                if (srcX >= 0 && srcX < width - 1 && srcY >= 0 && srcY < height - 1) {
                    var i = (width * srcY + srcX) * 4;
                    nw = [inputData[i], inputData[i + 1], inputData[i + 2], inputData[i + 3]];
                    ne = [inputData[i + 4], inputData[i + 5], inputData[i + 6], inputData[i + 7]];
                    sw = [inputData[i + width * 4], inputData[i + width * 4 + 1], inputData[i + width * 4 + 2], inputData[i + width * 4 + 3]];
                    se = [inputData[i + (width + 1) * 4], inputData[i + (width + 1) * 4 + 1], inputData[i + (width + 1) * 4 + 2], inputData[i + (width + 1) * 4 + 3]];

                } else {
                    nw = this.getPixel(inputData, srcX, srcY, width, height);
                    ne = this.getPixel(inputData, srcX + 1, srcY, width, height);
                    sw = this.getPixel(inputData, srcX, srcY + 1, width, height);
                    se = this.getPixel(inputData, srcX + 1, srcY + 1, width, height);
                }
                var rgba = this.bilinearInterpolate(xWeight, yWeight, nw, ne, sw, se);
                outputData[pixel] = rgba[0];
                outputData[pixel + 1] = rgba[1];
                outputData[pixel + 2] = rgba[2];
                outputData[pixel + 3] = rgba[3];
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}


//FILTERS 2

/**
 * Produces a water ripple/waves on the image. CenterX and CenterY specify the
 * position in terms of ratios of width and height.
 */
function WaterRippleFilter() {
    this.name = "Water Ripples";
    this.defaultValues = {
        phase: 0,
        radius: 50,
        wavelength: 16,
        amplitude: 10,
        centerX: 0.5,
        centerY: 0.5
    };
    this.valueRanges = {
        phase: { min: 0, max: 100 },
        radius: { min: 1, max: 200 },
        wavelength: { min: 1, max: 100 },
        amplitude: { min: 1, max: 100 },
        centerX: { min: 0.0, max: 1.0 },
        centerY: { min: 0.0, max: 1.0 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();

    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var wavelength = (values.wavelength === undefined) ? this.defaultValues.wavelength : values.wavelength;
        var amplitude = (values.amplitude === undefined) ? this.defaultValues.amplitude : values.amplitude;
        var phase = (values.phase === undefined) ? this.defaultValues.phase : values.phase;
        var centerX = (values.centerX === undefined) ? this.defaultValues.centerX : values.centerX;
        var centerY = (values.centerY === undefined) ? this.defaultValues.centerY : values.centerY;
        var radius = (values.radius === undefined) ? this.defaultValues.radius : values.radius;
        var radius2 = radius * radius;
        var iCenterX = width * centerX; var iCenterY = height * centerY;
        var transInverse = function (x, y, out) {
            var dx = x - iCenterX;
            var dy = y - iCenterY;
            var distance2 = dx * dx + dy * dy;
            if (distance2 > radius2) {
                out[0] = x;
                out[1] = y;
            } else {
                var distance = Math.sqrt(distance2);
                var amount = amplitude * Math.sin(distance / wavelength * Math.PI * 2 - phase);
                amount *= (radius - distance) / radius;
                if (distance != 0) {
                    amount *= wavelength / distance;
                }
                out[0] = x + dx * amount;
                out[1] = y + dy * amount;
            }
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}

/**
 * Smears out the image with circular shapes to create a painting style effect.
 * The mix values sets the intensity of the effect.
 * NOTE: This filter can be very slow, especially at higher densities/sizes. Use with caution.
 */
function CircleSmearFilter() {
    this.name = "Circle Smear";
    this.defaultValues = {
        size: 4,
        density: 0.5,
        mix: 0.5,
    };
    this.valueRanges = {
        size: { min: 1, max: 10 },
        density: { min: 0.0, max: 1.0 },
        mix: { min: 0.0, max: 1.0 },
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        for (var k = 0; k < inputData.length; k++) {
            outputData[k] = inputData[k];
        }
        if (values === undefined) { values = this.defaultValues; }
        var size = (values.size === undefined) ? this.defaultValues.size : values.size;
        if (size < 1) { size = 1; }
        size = parseInt(size);
        var density = (values.density === undefined) ? this.defaultValues.density : values.density;
        var mix = (values.mix === undefined) ? this.defaultValues.mix : values.mix;
        var radius = size + 1;
        var radius2 = radius * radius;
        var numShapes = parseInt(2 * density / 30 * width * height / 2);
        for (var i = 0; i < numShapes; i++) {
            var sx = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % width;
            var sy = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % height;
            var rgb2 = [inputData[(sy * width + sx) * 4], inputData[(sy * width + sx) * 4 + 1], inputData[(sy * width + sx) * 4 + 2], inputData[(sy * width + sx) * 4 + 3]];
            for (var x = sx - radius; x < sx + radius + 1; x++) {
                for (var y = sy - radius; y < sy + radius + 1; y++) {
                    var f = (x - sx) * (x - sx) + (y - sy) * (y - sy);
                    if (x >= 0 && x < width && y >= 0 && y < height && f <= radius2) {
                        var rgb1 = [outputData[(y * width + x) * 4], outputData[(y * width + x) * 4 + 1], outputData[(y * width + x) * 4 + 2], outputData[(y * width + x) * 4 + 3]];
                        var mixedRGB = filterUtils.mixColors(mix, rgb1, rgb2)
                        for (var k = 0; k < 3; k++) {
                            outputData[(y * width + x) * 4 + k] = mixedRGB[k];
                        }
                    }
                }
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}

/**
 * Diffuses the image creating a frosted glass effect.
 */


/**
 * Dithers the image to the specified number of colors. Setting color to false
 * grayscales the image.
 */
function DitherFilter() {
    this.name = "Dither";
    this.defaultValues = {
        levels: 3,
        color: true
    };
    this.valueRanges = {
        levels: { min: 2, max: 30 },
        color: { min: false, max: true }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        for (var i = 0; i < inputData.length; i++) {
            outputData[i] = 0;
        };
        if (values === undefined) { values = this.defaultValues; }
        var levels = (values.levels === undefined) ? this.defaultValues.levels : values.levels;
        var color = (values.color === undefined) ? this.defaultValues.color : values.color;
        if (levels <= 1) {
            levels = 1;
        }
        var matrix = [0, 0, 0,
            0, 0, 7,
            3, 5, 1];
        var sum = 7 + 3 + 5 + 1;
        var index = 0;
        var map = [];
        for (var i = 0; i < levels; i++) {
            map[i] = parseInt(255 * i / (levels - 1));
        };
        var div = [];
        for (var i = 0; i < 256; i++) {
            div[i] = parseInt(levels * i / 256);
        };
        for (var y = 0; y < height; y++) {
            var reverse = ((y & 1) == 1);
            var direction;
            if (reverse) {
                index = (y * width + width - 1) * 4;
                direction = -1
            } else {
                index = y * width * 4;
                direction = 1;
            }
            for (var x = 0; x < width; x++) {
                var r1 = inputData[index]; var g1 = inputData[index + 1]; var b1 = inputData[index + 2];
                if (!color) {
                    r1 = g1 = b1 = parseInt((r1 + g1 + b1) / 3);
                }
                var r2 = map[div[r1]]; var g2 = map[div[g1]]; var b2 = map[div[b1]];

                outputData[index] = r2; outputData[index + 1] = g2; outputData[index + 2] = b2; outputData[index + 3] = inputData[index + 3];

                var er = r1 - r2; var eg = g1 - g2; var eb = b1 - b2;

                for (var i = -1; i <= 1; i++) {
                    var iy = i + y;
                    if (0 <= iy && iy < height) {
                        for (var j = -1; j <= 1; j++) {
                            var jx = j + x;
                            if (0 <= jx && jx < width) {
                                var w;
                                if (reverse) {
                                    w = matrix[(i + 1) * 3 - j + 1];
                                } else {
                                    w = matrix[(i + 1) * 3 + j + 1];
                                }
                                if (w != 0) {
                                    var k = (reverse) ? index - j * 4 : index + j * 4;
                                    r1 = inputData[k]; g1 = inputData[k + 1]; b1 = inputData[k + 2];
                                    var factor = w / sum;
                                    r1 += er * factor; g1 += eg * factor; b1 += eb * factor;
                                    inputData[k] = r1; inputData[k + 1] = g1; inputData[k + 2] = b1;
                                }
                            }
                        }
                    }
                }
                index += direction * 4;
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}


/**
 * Adjusts the gain and bias of the image. Gain alters the contrast while bias biases
 * colors towards lighter or darker.
 */
function GainFilter() {
    this.name = "Gain/Bias";
    this.defaultValues = {
        gain: 0.5,
        bias: 0.5
    };
    this.valueRanges = {
        gain: { min: 0.0, max: 1.0 },
        bias: { min: 0.0, max: 1.0 }
    };
    var table = [];
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var gain = (values.gain === undefined) ? this.defaultValues.gain : values.gain;
        var bias = (values.bias === undefined) ? this.defaultValues.bias : values.bias;

        var table = [];

        for (var i = 0; i < 256; i++) {
            var val = i / 255;
            var k = (1 / gain - 2) * (1 - 2 * val);
            val = (val < 0.5) ? val / (k + 1) : (k - val) / (k - 1);
            val /= (1 / bias - 2) * (1 - val) + 1;
            table[i] = parseInt(255 * val);
        }
        filterUtils.tableFilter(inputData, table, width, height);
    }
}
/**
 * Creates a kaleidoscope effect on the image. CenterX and CenterY specify the
 * position in terms of ratios of width and height.
 */
function KaleidoscopeFilter() {
    this.name = "Kaleidoscope";
    this.defaultValues = {
        angle: 0,
        rotation: 0,
        sides: 3,
        centerX: 0.5,
        centerY: 0.5
    };
    this.valueRanges = {
        angle: { min: 0, max: 360 },
        rotation: { min: 0, max: 360 },
        sides: { min: 1, max: 30 },
        centerX: { min: 0.0, max: 1.0 },
        centerY: { min: 0.0, max: 1.0 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var angle = (values.angle === undefined) ? this.defaultValues.angle : values.angle;
        var rotation = (values.rotation === undefined) ? this.defaultValues.rotation : values.rotation;
        var sides = (values.sides === undefined) ? this.defaultValues.sides : values.sides;
        var centerX = (values.centerX === undefined) ? this.defaultValues.centerX : values.centerX;
        var centerY = (values.centerY === undefined) ? this.defaultValues.centerY : values.centerY;
        var iCenterX = width * centerX; var iCenterY = height * centerY;
        angle = angle / 180 * Math.PI;
        rotation = rotation / 180 * Math.PI;
        var transInverse = function (x, y, out) {
            var dx = x - iCenterX;
            var dy = y - iCenterY;
            var r = Math.sqrt(dx * dx + dy * dy);
            var theta = Math.atan2(dy, dx) - angle - rotation;
            theta = filterUtils.triangle(theta / Math.PI * sides * 0.5);
            theta += angle;
            out[0] = iCenterX + r * Math.cos(theta);
            out[1] = iCenterY + r * Math.sin(theta);
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}

/**
 * Applies a fisheye lens distortion effect on the image. CenterX and CenterY specify the
 * position in terms of ratios of width and height.
 */
export function LensDistortionFilter() {
    this.name = "Lens Distortion";
    this.defaultValues = {
        refraction: 1.5,
        radius: 50,
        centerX: 0.5,
        centerY: 0.5
    };
    this.valueRanges = {
        refraction: { min: 1, max: 10 },
        radius: { min: 1, max: 200 },
        centerX: { min: 0.0, max: 1.0 },
        centerY: { min: 0.0, max: 1.0 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();

    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var refraction = (values.refraction === undefined) ? this.defaultValues.refraction : values.refraction;
        var centerX = (values.centerX === undefined) ? this.defaultValues.centerX : values.centerX;
        var centerY = (values.centerY === undefined) ? this.defaultValues.centerY : values.centerY;
        var radius = (values.radius === undefined) ? this.defaultValues.radius : values.radius;
        var radius2 = radius * radius;
        var iCenterX = width * centerX; var iCenterY = height * centerY;
        var transInverse = function (x, y, out) {
            var dx = x - iCenterX;
            var dy = y - iCenterY;
            var x2 = dx * dx;
            var y2 = dy * dy;
            if (y2 >= (radius2 - (radius2 * x2) / radius2)) {
                out[0] = x;
                out[1] = y;
            } else {
                var rRefraction = 1.0 / refraction;

                var z = Math.sqrt((1.0 - x2 / radius2 - y2 / radius2) * radius2);
                var z2 = z * z;

                var xAngle = Math.acos(dx / Math.sqrt(x2 + z2));
                var angle1 = Math.PI / 2 - xAngle;
                var angle2 = Math.asin(Math.sin(angle1) * rRefraction);
                angle2 = Math.PI / 2 - xAngle - angle2;
                out[0] = x - Math.tan(angle2) * z;

                var yAngle = Math.acos(dy / Math.sqrt(y2 + z2));
                angle1 = Math.PI / 2 - yAngle;
                angle2 = Math.asin(Math.sin(angle1) * rRefraction);
                angle2 = Math.PI / 2 - yAngle - angle2;
                out[1] = y - Math.tan(angle2) * z;
            }
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}
/**
 * Smears out the image with line shapes to create a painting style effect. Mix specifies
 * the intensity of the effect.
 */
function LineSmearFilter() {
    this.name = "Line Smear";
    this.defaultValues = {
        distance: 8,
        density: 0.5,
        angle: 0,
        mix: 0.5,
    };
    this.valueRanges = {
        distance: { min: 1, max: 30 },
        density: { min: 0.0, max: 1.0 },
        angle: { min: 0, max: 360 },
        mix: { min: 0.0, max: 1.0 },
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        for (var k = 0; k < inputData.length; k++) {
            outputData[k] = inputData[k];
        }
        if (values === undefined) { values = this.defaultValues; }
        var distance = (values.distance === undefined) ? this.defaultValues.distance : values.distance;
        if (distance < 1) { distance = 1; }
        distance = parseInt(distance);
        var density = (values.density === undefined) ? this.defaultValues.density : values.density;
        var angle = (values.angle === undefined) ? this.defaultValues.angle : values.angle;
        var mix = (values.mix === undefined) ? this.defaultValues.mix : values.mix;
        angle = angle / 180 * Math.PI;
        var sinAngle = Math.sin(angle);
        var cosAngle = Math.cos(angle);
        var numShapes = parseInt(2 * density * width * height / 2);
        for (var i = 0; i < numShapes; i++) {
            var sx = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % width;
            var sy = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % height;
            var length = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % distance + 1;
            var rgb2 = [inputData[(sy * width + sx) * 4], inputData[(sy * width + sx) * 4 + 1], inputData[(sy * width + sx) * 4 + 2], inputData[(sy * width + sx) * 4 + 3]];
            var dx = parseInt(length * cosAngle);
            var dy = parseInt(length * sinAngle);

            var x0 = sx - dx;
            var y0 = sy - dy;
            var x1 = sx + dx;
            var y1 = sy + dy;
            var x, y, d, incrE, incrNE, ddx, ddy;

            if (x1 < x0) {
                ddx = -1;
            } else {
                ddx = 1;
            }
            if (y1 < y0) {
                ddy = -1;
            } else {
                ddy = 1;
            }
            dx = x1 - x0;
            dy = y1 - y0;
            dx = Math.abs(dx);
            dy = Math.abs(dy);
            x = x0;
            y = y0;

            if (x < width && x >= 0 && y < height && y >= 0) {
                var rgb1 = [outputData[(y * width + x) * 4], outputData[(y * width + x) * 4 + 1], outputData[(y * width + x) * 4 + 2], outputData[(y * width + x) * 4 + 3]];
                var mixedRGB = filterUtils.mixColors(mix, rgb1, rgb2)
                for (var k = 0; k < 3; k++) {
                    outputData[(y * width + x) * 4 + k] = mixedRGB[k];
                }
            }
            if (Math.abs(dx) > Math.abs(dy)) {
                d = 2 * dy - dx;
                incrE = 2 * dy;
                incrNE = 2 * (dy - dx);

                while (x != x1) {
                    if (d <= 0)
                        d += incrE;
                    else {
                        d += incrNE;
                        y += ddy;
                    }
                    x += ddx;
                    if (x < width && x >= 0 && y < height && y >= 0) {
                        var rgb1 = [outputData[(y * width + x) * 4], outputData[(y * width + x) * 4 + 1], outputData[(y * width + x) * 4 + 2], outputData[(y * width + x) * 4 + 3]];
                        var mixedRGB = filterUtils.mixColors(mix, rgb1, rgb2)
                        for (var k = 0; k < 3; k++) {
                            outputData[(y * width + x) * 4 + k] = mixedRGB[k];
                        }
                    }
                }
            } else {
                d = 2 * dx - dy;
                incrE = 2 * dx;
                incrNE = 2 * (dx - dy);

                while (y != y1) {
                    if (d <= 0)
                        d += incrE;
                    else {
                        d += incrNE;
                        x += ddx;
                    }
                    y += ddy;
                    if (x < width && x >= 0 && y < height && y >= 0) {
                        var rgb1 = [outputData[(y * width + x) * 4], outputData[(y * width + x) * 4 + 1], outputData[(y * width + x) * 4 + 2], outputData[(y * width + x) * 4 + 3]];
                        var mixedRGB = filterUtils.mixColors(mix, rgb1, rgb2)
                        for (var k = 0; k < 3; k++) {
                            outputData[(y * width + x) * 4 + k] = mixedRGB[k];
                        }
                    }
                }
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}

export function DiffusionFilter() {
    this.name = "Diffusion";
    this.defaultValues = {
        scale: 4
    };
    this.valueRanges = {
        scale: { min: 1, max: 100 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values, isRadius, silhouette) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var scale = (values.scale === undefined) ? this.defaultValues.scale : values.scale;
        var out = [];
        var outputData = [];
        var sinTable = [];
        var cosTable = [];
        for (var i = 0; i < 256; i++) {
            var angle = Math.PI * 2 * i / 256;
            sinTable[i] = scale * Math.sin(angle);
            cosTable[i] = scale * Math.cos(angle);
        }

        function transInverse(x, y, out) {
            var angle = parseInt(Math.random() * 255);
            var distance = Math.random();
            out[0] = x + distance * sinTable[angle];
            out[1] = y + distance * cosTable[angle];
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}

export function NoiseFilter() {
    this.name = "Noise";
    this.defaultValues = {
        amount: 25,
        density: 1,
        monochrome: true
    };
    this.valueRanges = {
        amount: { min: 0, max: 100 },
        density: { min: 0, max: 1.0 },
        monochrome: { min: false, max: true }
    };
    this.filter = function (input, values, isRadius, silhouette, excludes) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var density = (values.density === undefined) ? this.defaultValues.density : values.density;
        var monochrome = (values.monochrome === undefined) ? this.defaultValues.monochrome : values.monochrome;

        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                if (Math.random() <= density) {
                    if (monochrome) {
                        var n = parseInt((2 * Math.random() - 1) * amount);
                        inputData[pixel] += n;
                        inputData[pixel + 1] += n;
                        inputData[pixel + 2] += n;
                    } else {
                        for (var i = 0; i < 3; i++) {
                            var n = parseInt((2 * Math.random() - 1) * amount);
                            inputData[pixel + i] += n;
                        }
                    }
                }
            }
        }
    }
}
/**
 * Pinches and whirls the image toward the center point. CenterX and CenterY specify the
 * position in terms of ratios of width and height.
 */
export function PinchFilter() {
    this.name = "Pinch/Whirl";
    this.defaultValues = {
        amount: 0.5,
        radius: 100,
        angle: 0,
        centerX: 0.5,
        centerY: 0.5
    };
    this.valueRanges = {
        amount: { min: -1.0, max: 1.0 },
        radius: { min: 1, max: 200 },
        angle: { min: 0, max: 360 },
        centerX: { min: 0.0, max: 1.0 },
        centerY: { min: 0.0, max: 1.0 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();

    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var angle = (values.angle === undefined) ? this.defaultValues.angle : values.angle;
        var centerX = (values.centerX === undefined) ? this.defaultValues.centerX : values.centerX;
        var centerY = (values.centerY === undefined) ? this.defaultValues.centerY : values.centerY;
        var radius = (values.radius === undefined) ? this.defaultValues.radius : values.radius;
        var radius2 = radius * radius;
        angle = angle / 180 * Math.PI;
        var iCenterX = width * centerX; var iCenterY = height * centerY;
        var transInverse = function (x, y, out) {
            var dx = x - iCenterX;
            var dy = y - iCenterY;
            var distance = dx * dx + dy * dy;
            if (distance > radius2 || distance == 0) {
                out[0] = x;
                out[1] = y;
            } else {
                var d = Math.sqrt(distance / radius2);
                var t = Math.pow(Math.sin(Math.PI * 0.5 * d), -amount);

                dx *= t;
                dy *= t;

                var e = 1 - d;
                var a = angle * e * e;

                var s = Math.sin(a);
                var c = Math.cos(a);

                out[0] = iCenterX + c * dx - s * dy;
                out[1] = iCenterY + s * dx + c * dy;
            }
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}

/**
 * Pixelates the image i.e. divides the image into blocks of color.
 */
export function PixelationFilter() {
    this.name = "Pixelation";
    this.defaultValues = {
        size: 5
    };
    this.valueRanges = {
        size: { min: 1, max: 50 }
    };
    this.filter = function (input, values, isRadius, silhouette, excludes) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var size = (values.size === undefined) ? this.defaultValues.size : values.size;
        size = parseInt(size);
        var pixels = [];
        _log("rafius", values)
        for (var y = 0; y < height; y += size) {
            for (var x = 0; x < width; x += size) {

                var pixel = (y * width + x) * 4;
                var w = Math.min(size, width - x);
                var h = Math.min(size, height - y);
                var t = w * h;
                var r = 0, g = 0, b = 0;
                for (var by = y; by < y + h; by++) {
                    for (var bx = x; bx < x + w; bx++) {
                        var bPixel = (by * width + bx) * 4;
                        r += inputData[bPixel];
                        g += inputData[bPixel + 1];
                        b += inputData[bPixel + 2];
                    }
                }
                for (var by = y; by < y + h; by++) {
                    for (var bx = x; bx < x + w; bx++) {
                        var bPixel = (by * width + bx) * 4;
                        inputData[bPixel] = r / t;
                        inputData[bPixel + 1] = g / t;
                        inputData[bPixel + 2] = b / t;
                    }
                }
            }
        }
    }
}


/**
 * Adjust the factor of each RGB color value in the image.
 */
function RGBAdjustFilter() {
    this.name = "RGBAdjust";
    this.defaultValues = {
        red: 1.0,
        green: 1.0,
        blue: 1.0
    };
    this.valueRanges = {
        red: { min: 0.0, max: 2.0 },
        green: { min: 0.0, max: 2.0 },
        blue: { min: 0.0, max: 2.0 }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var red = (values.red === undefined) ? this.defaultValues.red : values.red;
        var green = (values.green === undefined) ? this.defaultValues.green : values.green;
        var blue = (values.blue === undefined) ? this.defaultValues.blue : values.blue;
        if (red < 0) { red = 0; }
        if (green < 0) { green = 0; }
        if (blue < 0) { blue = 0; }
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                inputData[pixel] *= red;
                inputData[pixel + 1] *= green;
                inputData[pixel + 2] *= blue;
            }
        }
    }
}

/**
 * Creates ripples on the image horizontally/vertically in a sine pattern.
 */
function SineRippleFilter() {
    this.name = "Sine Ripples";
    this.defaultValues = {
        xAmplitude: 5,
        yAmplitude: 5,
        xWavelength: 16,
        yWavelength: 16
    };
    this.valueRanges = {
        xAmplitude: { min: 0, max: 30 },
        yAmplitude: { min: 0, max: 30 },
        xWavelength: { min: 1, max: 50 },
        yWavelength: { min: 1, max: 50 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();

    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var xAmplitude = (values.xAmplitude === undefined) ? this.defaultValues.xAmplitude : values.xAmplitude;
        var yAmplitude = (values.yAmplitude === undefined) ? this.defaultValues.yAmplitude : values.yAmplitude;
        var xWavelength = (values.xWavelength === undefined) ? this.defaultValues.xWavelength : values.xWavelength;
        var yWavelength = (values.yWavelength === undefined) ? this.defaultValues.yWavelength : values.yWavelength;
        var transInverse = function (x, y, out) {
            var nx = y / xWavelength;
            var ny = x / yWavelength;
            var fx = Math.sin(nx);
            var fy = Math.sin(ny);
            out[0] = x + xAmplitude * fx;
            out[1] = y + yAmplitude * fy;
        }
        filterUtils.transformFilter(inputData, transInverse, width, height);
    }
}
/**
 * Generates a sparkle/sunburst effect on the image. CenterX and CenterY specify the
 * position in terms of ratios of width and height.
 */
function SparkleFilter() {
    this.name = "Sparkle";
    this.defaultValues = {
        rays: 50,
        radius: 25,
        amount: 50,
        randomness: 25,
        centerX: 0.5,
        centerY: 0.5,
    };
    this.valueRanges = {
        rays: { min: 1, max: 100 },
        radius: { min: 1, max: 200 },
        amount: { min: 0, max: 100 },
        randomness: { min: 0, max: 50 },
        centerX: { min: 0, max: 1.0 },
        centerY: { min: 0, max: 1.0 },
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var rays = (values.rays === undefined) ? this.defaultValues.rays : values.rays;
        var radius = (values.radius === undefined) ? this.defaultValues.radius : values.radius;
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var randomness = (values.randomness === undefined) ? this.defaultValues.randomness : values.randomness;
        var centerX = (values.centerX === undefined) ? this.defaultValues.centerX : values.centerX;
        var centerY = (values.centerY === undefined) ? this.defaultValues.centerY : values.centerY;
        var iCenterX = centerX * width;
        var iCenterY = centerY * height;
        var rayLengths = [];
        for (var i = 0; i < rays; i++) {
            rayLengths[i] = radius + randomness / 100 * radius * filterUtils.gaussianRandom();
        }
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var dx = x - iCenterX;
                var dy = y - iCenterY;
                var distance = dx * dx + dy * dy;
                var angle = Math.atan2(dy, dx);
                var d = (angle + Math.PI) / (Math.PI * 2) * rays;
                var i = parseInt(d);
                var f = d - i;
                if (radius != 0) {
                    var length = filterUtils.linearInterpolate(f, rayLengths[i % rays], rayLengths[(i + 1) % rays]);
                    var g = length * length / (distance + 0.0001);
                    g = Math.pow(g, (100 - amount) / 50);
                    f -= 0.5;
                    f = 1 - f * f;
                    f *= g;
                }
                f = filterUtils.clampPixel(f, 0, 1);
                var mixedRGB = filterUtils.mixColors(f, [inputData[pixel], inputData[pixel + 1], inputData[pixel + 2], inputData[pixel + 3]], [255, 255, 255, 255]);
                for (var k = 0; k < 3; k++) {
                    inputData[pixel + k] = mixedRGB[k];
                }
            }
        }
    }
}
/**
 * Creates a classical vignette effect on the image i.e. darkens the corners.
 */
function VignetteFilter() {
    this.name = "Vignette";
    this.defaultValues = {
        amount: 0.3,
    };
    this.valueRanges = {
        amount: { min: 0.0, max: 1.0 },
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext("2d");
        var gradient;
        var radius = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
        context.putImageData(input, 0, 0);
        context.globalCompositeOperation = 'source-over';

        gradient = context.createRadialGradient(width / 2, height / 2, 0, width / 2, height / 2, radius);
        gradient.addColorStop(0, 'rgba(0,0,0,0)');
        gradient.addColorStop(0.5, 'rgba(0,0,0,0)');
        gradient.addColorStop(1, 'rgba(0,0,0,' + amount + ')');
        context.fillStyle = gradient;
        context.fillRect(0, 0, width, height);
        outputData = context.getImageData(0, 0, width, height).data;
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}
/**
 * Smears out the image with square shapes to create a painting style effect.
 * The mix values sets the intensity of the effect.
 * NOTE: This filter can be very slow, especially at higher densities/sizes. Use with caution.
 */
function SquareSmearFilter() {
    this.name = "Square Smear";
    this.defaultValues = {
        size: 4,
        density: 0.5,
        mix: 0.5,
    };
    this.valueRanges = {
        size: { min: 1, max: 10 },
        density: { min: 0.0, max: 1.0 },
        mix: { min: 0.0, max: 1.0 },
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        for (var k = 0; k < inputData.length; k++) {
            outputData[k] = inputData[k];
        }
        if (values === undefined) { values = this.defaultValues; }
        var size = (values.size === undefined) ? this.defaultValues.size : values.size;
        if (size < 1) { size = 1; }
        size = parseInt(size);
        var density = (values.density === undefined) ? this.defaultValues.density : values.density;
        var mix = (values.mix === undefined) ? this.defaultValues.mix : values.mix;
        var radius = size + 1;
        var radius2 = radius * radius;
        var numShapes = parseInt(2 * density / 30 * width * height / 2);
        for (var i = 0; i < numShapes; i++) {
            var sx = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % width;
            var sy = (Math.random() * Math.pow(2, 32) & 0x7fffffff) % height;
            var rgb2 = [inputData[(sy * width + sx) * 4], inputData[(sy * width + sx) * 4 + 1], inputData[(sy * width + sx) * 4 + 2], inputData[(sy * width + sx) * 4 + 3]];
            for (var x = sx - radius; x < sx + radius + 1; x++) {

                for (var y = sy - radius; y < sy + radius + 1; y++) {
                    if (x >= 0 && x < width && y >= 0 && y < height) {
                        var rgb1 = [outputData[(y * width + x) * 4], outputData[(y * width + x) * 4 + 1], outputData[(y * width + x) * 4 + 2], outputData[(y * width + x) * 4 + 3]];
                        var mixedRGB = filterUtils.mixColors(mix, rgb1, rgb2)
                        for (var k = 0; k < 3; k++) {
                            outputData[(y * width + x) * 4 + k] = mixedRGB[k];
                        }
                    }
                }
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}

function EdgeFilter() {
    this.name = "Edge Detection";
    var matrixH = [-1, -2, -1,
        0, 0, 0,
        1, 2, 1];
    var matrixV = [-1, 0, 1,
    -2, 0, 2,
    -1, 0, 1];
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var outputData = [];
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var rh = 0; var gh = 0; var bh = 0;
                var rv = 0; var gv = 0; var bv = 0;
                for (var row = -1; row <= 1; row++) {
                    var iy = y + row;
                    var ioffset;
                    if (iy >= 0 && iy < height) {
                        ioffset = iy * width * 4;
                    } else {
                        ioffset = y * width * 4;
                    }
                    var moffset = 3 * (row + 1) + 1;
                    for (var col = -1; col <= 1; col++) {
                        var ix = x + col;
                        if (!(ix >= 0 && ix < width)) {
                            ix = x;
                        }
                        ix *= 4;
                        var r = inputData[ioffset + ix];
                        var g = inputData[ioffset + ix + 1];
                        var b = inputData[ioffset + ix + 2];
                        var h = matrixH[moffset + col];
                        var v = matrixV[moffset + col];
                        rh += parseInt(h * r);
                        bh += parseInt(h * g);
                        gh += parseInt(h * b);
                        rv += parseInt(v * r);
                        gv += parseInt(v * g);
                        bv += parseInt(v * b);
                    }
                }
                r = parseInt(Math.sqrt(rh * rh + rv * rv) / 1.8);
                g = parseInt(Math.sqrt(gh * gh + gv * gv) / 1.8);
                b = parseInt(Math.sqrt(bh * bh + bv * bv) / 1.8);

                outputData[pixel] = r;
                outputData[pixel + 1] = g;
                outputData[pixel + 2] = b;
                outputData[pixel + 3] = inputData[pixel + 3];
            }
        }
        for (var k = 0; k < outputData.length; k++) {
            inputData[k] = outputData[k];
        }
    }
}
/**
 * Divides the colors into black and white following the treshold value. Brightnesses above the threshold
 * sets the color to white while values below the threshold sets the color to black.
 */
function ThresholdFilter() {
    this.name = "Black & White";
    this.defaultValues = {
        threshold: 127
    };
    this.valueRanges = {
        threshold: { min: 0, max: 255 }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var threshold = (values.threshold === undefined) ? this.defaultValues.threshold : values.threshold;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var brightness = (inputData[pixel] + inputData[pixel + 1] + inputData[pixel + 2]) / 3
                var colorVal = 0;
                if (brightness > threshold) {
                    colorVal = 255;
                }
                inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = colorVal;
            }
        }
    }
}
/**
 * Embosses the image with a simulated light source. 
 * Angle and elevation sets the position of the light.
 */
function EmbossFilter() {
    this.name = "Emboss";
    this.defaultValues = {
        height: 1,
        angle: 135,
        elevation: 30
    };
    this.valueRanges = {
        height: { min: 1, max: 10 },
        angle: { min: 0, max: 360 },
        elevation: { min: 0, max: 180 }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var bumpHeight = (values.height === undefined) ? this.defaultValues.height : values.height;
        var angle = (values.angle === undefined) ? this.defaultValues.angle : values.angle;
        var elevation = (values.elevation === undefined) ? this.defaultValues.elevation : values.elevation;
        angle = angle / 180 * Math.PI;
        elevation = elevation / 180 * Math.PI;
        var width45 = 3 * bumpHeight;
        var pixelScale = 255.9;

        var bumpPixels = [];
        var bumpMapWidth = width;
        var bumpMapHeight = height;
        for (var i = 0; i < inputData.length; i += 4) {
            bumpPixels[i / 4] = (inputData[i] + inputData[i + 1] + inputData[i + 2]) / 3
        }
        var Nx, Ny, Nz, Lx, Ly, Lz, Nz2, NzLz, NdotL;
        var shade, background;

        Lx = parseInt(Math.cos(angle) * Math.cos(elevation) * pixelScale);
        Ly = parseInt(Math.sin(angle) * Math.cos(elevation) * pixelScale);
        Lz = parseInt(Math.sin(elevation) * pixelScale);

        Nz = parseInt(6 * 255 / width45);
        Nz2 = Nz * Nz;
        NzLz = Nz * Lz;
        background = Lz;

        var bumpIndex = 0;

        for (var y = 0; y < height; y++, bumpIndex += bumpMapWidth) {
            var s1 = bumpIndex;
            var s2 = s1 + bumpMapWidth;
            var s3 = s2 + bumpMapWidth;
            for (var x = 0; x < width; x++, s1++, s2++, s3++) {
                var pixel = (y * width + x) * 4;
                if (y != 0 && y < height - 2 && x != 0 && x < width - 2) {
                    Nx = bumpPixels[s1 - 1] + bumpPixels[s2 - 1] + bumpPixels[s3 - 1] - bumpPixels[s1 + 1] - bumpPixels[s2 + 1] - bumpPixels[s3 + 1];
                    Ny = bumpPixels[s3 - 1] + bumpPixels[s3] + bumpPixels[s3 + 1] - bumpPixels[s1 - 1] - bumpPixels[s1] - bumpPixels[s1 + 1];
                    if (Nx == 0 && Ny == 0) {
                        shade = background;
                    } else if ((NdotL = Nx * Lx + Ny * Ly + NzLz) < 0) {
                        shade = 0;
                    } else {
                        shade = parseInt(NdotL / Math.sqrt(Nx * Nx + Ny * Ny + Nz2));
                    }
                } else {
                    shade = background;
                }
                inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = shade;
            }
        }
    }
}

export function PencilFilter() {
    this.name = "Emboss";
    this.defaultValues = {
        height: 10,
        angle: 0,
        elevation: 100,
        amount: 2,
        gain: 0.5,
        bias: 0.5,
        noise: 0,
        density: .5,
    };
    this.valueRanges = {
        height: { min: 1, max: 10 },
        angle: { min: 0, max: 360 },
        elevation: { min: 0, max: 180 },
        gain: { min: 0.0, max: 1.0 },
        bias: { min: 0.0, max: 1.0 }
    };
    this.filter = function (input, values) {
        var inputData = input.data;
        var noise = (values.noise === undefined) ? this.defaultValues.noise : values.noise;

        if (noise) {
            new OldMovieFilter().filter(input, { amount: noise + 2 });
        }

        new GainFilter().filter(input, { gain: values.gain, bias: .7 })
        var width = input.width, height = input.height;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var bumpHeight = (values.height === undefined) ? this.defaultValues.height : values.height;
        var density = (values.density === undefined) ? this.defaultValues.density : values.density;
        var angle = (values.angle === undefined) ? this.defaultValues.angle : values.angle;
        var elevation = (values.elevation === undefined) ? this.defaultValues.elevation : values.elevation;
        angle = angle / 180 * Math.PI;
        elevation = elevation / 180 * Math.PI;
        var width45 = 3 * bumpHeight;
        var pixelScale = 255.9;

        var bumpPixels = [];
        var bumpMapWidth = width;
        var bumpMapHeight = height;


        for (var i = 0; i < inputData.length; i += 4) {
            bumpPixels[i / 4] = (inputData[i] + inputData[i + 1] + inputData[i + 2]) / 3
        }
        var Nx, Ny, Nz, Lx, Ly, Lz, Nz2, NzLz, NdotL;
        var shade, background;

        Lx = parseInt(Math.cos(angle) * Math.cos(elevation) * pixelScale);
        Ly = parseInt(Math.sin(angle) * Math.cos(elevation) * pixelScale);
        Lz = parseInt(Math.sin(elevation) * pixelScale);

        Nz = parseInt(6 * 255 / width45);
        Nz2 = Nz * Nz;
        NzLz = Nz * Lz;
        background = Lz;

        var bumpIndex = 0;
        //saturate
        var RW = 0.3086;
        var RG = 0.6084;
        var RB = 0.0820;
        var a = (1 - amount) * RW + amount;
        var b = (1 - amount) * RW;
        var c = (1 - amount) * RW;
        var d = (1 - amount) * RG;
        var e = (1 - amount) * RG + amount;
        var f = (1 - amount) * RG;
        var g = (1 - amount) * RB;
        var h = (1 - amount) * RB;
        var i = (1 - amount) * RB + amount;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;

                inputData[pixel] = a * inputData[pixel] + d * inputData[pixel + 1] + g * inputData[pixel + 2];
                inputData[pixel + 1] = b * inputData[pixel] + e * inputData[pixel + 1] + h * inputData[pixel + 2];
                inputData[pixel + 2] = c * inputData[pixel] + f * inputData[pixel + 1] + i * inputData[pixel + 2];


            }
        }
        for (var y = 0; y < height; y++, bumpIndex += bumpMapWidth) {
            var s1 = bumpIndex;
            var s2 = s1 + bumpMapWidth;
            var s3 = s2 + bumpMapWidth;
            for (var x = 0; x < width; x++, s1++, s2++, s3++) {
                var pixel = (y * width + x) * 4;
                if (y != 0 && y < height - 2 && x != 0 && x < width - 2) {
                    Nx = bumpPixels[s1 - 1] + bumpPixels[s2 - 1] + bumpPixels[s3 - 1] - bumpPixels[s1 + 1] - bumpPixels[s2 + 1] - bumpPixels[s3 + 1];
                    Ny = bumpPixels[s3 - 1] + bumpPixels[s3] + bumpPixels[s3 + 1] - bumpPixels[s1 - 1] - bumpPixels[s1] - bumpPixels[s1 + 1];
                    if (Nx == 0 && Ny == 0) {
                        shade = background;
                    } else if ((NdotL = Nx * Lx + Ny * Ly + NzLz) < 0) {
                        shade = 0;
                    } else {
                        shade = parseInt(NdotL / Math.sqrt(Nx * Nx + Ny * Ny + Nz2));
                    }
                } else {
                    shade = background;
                }
                inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = shade;
            }
        }

    }
}
/**
 * Embosses the edges of the image.
 * This filter takes no parameters but can be applied several times for
 * further effect.
 */
function BumpFilter() {
    this.name = "Bump";
    this.defaultValues = {
    };
    this.valueRanges = {
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var matrix = [-1, -1, 0,
        -1, 1, 1,
            0, 1, 1];
        filterUtils.convolveFilter(inputData, matrix, width, height);
    }
}


/**
 * Adjust simulated exposure values on the image.
 */
function ExposureFilter() {
    this.name = "Exposure";
    this.defaultValues = {
        exposure: 1.0
    };
    this.valueRanges = {
        exposure: { min: 0, max: 5 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var exposure = (values.exposure === undefined) ? this.defaultValues.exposure : values.exposure;
        var table = [];
        for (var i = 0; i < 256; i++) {
            table[i] = parseInt(255 * (1 - Math.exp(-(i / 255) * exposure)));
        }
        filterUtils.tableFilter(inputData, table, width, height);
    }
}
/**
 * Produces a solarization effect on the image.  
 */
function SolarizeFilter() {
    this.name = "Solarize";
    this.defaultValues = {
    };
    this.valueRanges = {
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var table = [];
        for (var i = 0; i < 256; i++) {
            var val = (i / 255 > 0.5) ? 2 * (i / 255 - 0.5) : 2 * (0.5 - i / 255)
            table[i] = parseInt(255 * val);
        }
        filterUtils.tableFilter(inputData, table, width, height);
    }
}

function GhostFilter() {
    this.name = "Ghost";
    this.defaultValues = {
    };
    this.valueRanges = {
        exposure: 5
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        var isGray = values.isGray || false;
        var exposure = (values.exposure === undefined) ? this.defaultValues.exposure : values.exposure;

        var table = [];
        for (var i = 0; i < 256; i++) {
            table[i] = parseInt(255 * (1 - Math.exp(-(i / 255) * exposure)));
        }
        filterUtils.tableFilter(inputData, table, width, height);
        table = [];
        for (var i = 0; i < 256; i++) {
            var val = (i / 255 > 0.5) ? 2 * (i / 255 - 0.5) : 2 * (0.5 - i / 255)
            table[i] = parseInt(255 * val);
        }
        filterUtils.tableFilter(inputData, table, width, height);
        if (isGray) {
            for (var y = 0; y < height; y++) {
                for (var x = 0; x < width; x++) {
                    var pixel = (y * width + x) * 4;
                    var luma = inputData[pixel] * 0.3 + inputData[pixel + 1] * 0.59 + inputData[pixel + 2] * 0.11;
                    inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = luma;
                }
            }
        }
    }
}
/**
 * Posterizes the image, i.e. restricts the color values to a set amount of levels.
 */
function PosterizeFilter() {
    this.name = "Posterize";
    this.defaultValues = {
        levels: 6
    };
    this.valueRanges = {
        levels: { min: 2, max: 30 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var levels = (values.levels === undefined) ? this.defaultValues.levels : parseInt(values.levels);
        if (levels <= 1) {
            return;
        }
        var table = [];
        for (var i = 0; i < 256; i++) {
            table[i] = parseInt(255 * parseInt(i * levels / 256) / (levels - 1));
        }
        filterUtils.tableFilter(inputData, table, width, height);
    }
}

/**
 * Adjusts the gamma values of the image. Values over 1 increase the gamma while values over 0 decrease gamma.
 */
function GammaFilter() {
    this.name = "Gamma";
    this.defaultValues = {
        amount: 1.0
    };
    this.valueRanges = {
        amount: { min: 0.0, max: 2.0 }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        if (amount < 0) {
            amount = 0.0;
        }
        if (!FilterUtils) {
            if (console) {
                console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
            }
            return;
        }
        var filterUtils = new FilterUtils();
        var table = [];
        for (var i = 0; i < 256; i++) {
            table[i] = 255 * Math.pow(i / 255, 1 / amount) + 0.5;
        }
        filterUtils.tableFilter(inputData, table, width, height);
    }
}

/**
 * Adjusts the saturation value of the image. Values over 1 increase saturation while values below decrease saturation.
 * For a true grayscale effect, use the grayscale filter instead.
 */
function SaturationFilter() {
    this.name = "Saturation";
    this.defaultValues = {
        amount: 1.0
    };
    this.valueRanges = {
        amount: { min: 0.0, max: 2.0 }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        var RW = 0.3086;
        var RG = 0.6084;
        var RB = 0.0820;
        var a = (1 - amount) * RW + amount;
        var b = (1 - amount) * RW;
        var c = (1 - amount) * RW;
        var d = (1 - amount) * RG;
        var e = (1 - amount) * RG + amount;
        var f = (1 - amount) * RG;
        var g = (1 - amount) * RB;
        var h = (1 - amount) * RB;
        var i = (1 - amount) * RB + amount;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                inputData[pixel] = a * inputData[pixel] + d * inputData[pixel + 1] + g * inputData[pixel + 2];
                inputData[pixel + 1] = b * inputData[pixel] + e * inputData[pixel + 1] + h * inputData[pixel + 2];
                inputData[pixel + 2] = c * inputData[pixel] + f * inputData[pixel + 1] + i * inputData[pixel + 2];
            }
        }
    }
}


function OilPaintFilter() {
    this.name = "OilPaintFilter";
    this.defaultValues = {
    };
    this.valueRanges = {
    };
    this.filter = function (input, values) {
        var intensity = values.intensity
        var radius = values.radius
        var width = input.width, height = input.height;
        var pixData = input.data;

        var pixelIntensityCount = [];

        var destImageData = new ImageData(width, height),
            destPixData = destImageData.data,
            intensityLUT = [],
            rgbLUT = [];

        for (var y = 0; y < height; y++) {
            intensityLUT[y] = [];
            rgbLUT[y] = [];
            for (var x = 0; x < width; x++) {
                var idx = (y * width + x) * 4,
                    r = pixData[idx],
                    g = pixData[idx + 1],
                    b = pixData[idx + 2],
                    avg = (r + g + b) / 3;

                intensityLUT[y][x] = Math.round((avg * intensity) / 255);
                rgbLUT[y][x] = {
                    r: r,
                    g: g,
                    b: b
                };
            }
        }


        for (y = 0; y < height; y++) {
            for (x = 0; x < width; x++) {
                pixelIntensityCount = [];

                // Find intensities of nearest pixels within radius.
                for (var yy = -radius; yy <= radius; yy++) {
                    for (var xx = -radius; xx <= radius; xx++) {
                        if (y + yy > 0 && y + yy < height && x + xx > 0 && x + xx < width) {
                            var intensityVal = intensityLUT[y + yy][x + xx];

                            if (!pixelIntensityCount[intensityVal]) {
                                pixelIntensityCount[intensityVal] = {
                                    val: 1,
                                    r: rgbLUT[y + yy][x + xx].r,
                                    g: rgbLUT[y + yy][x + xx].g,
                                    b: rgbLUT[y + yy][x + xx].b
                                }
                            } else {
                                pixelIntensityCount[intensityVal].val++;
                                pixelIntensityCount[intensityVal].r += rgbLUT[y + yy][x + xx].r;
                                pixelIntensityCount[intensityVal].g += rgbLUT[y + yy][x + xx].g;
                                pixelIntensityCount[intensityVal].b += rgbLUT[y + yy][x + xx].b;
                            }
                        }
                    }
                }

                pixelIntensityCount.sort(function (a, b) {
                    return b.val - a.val;
                });

                var curMax = pixelIntensityCount[0].val,
                    dIdx = (y * width + x) * 4;

                destPixData[dIdx] = ~~(pixelIntensityCount[0].r / curMax);
                destPixData[dIdx + 1] = ~~(pixelIntensityCount[0].g / curMax);
                destPixData[dIdx + 2] = ~~(pixelIntensityCount[0].b / curMax);
                destPixData[dIdx + 3] = 255;
            }
        }
        return destImageData;
    }
}

/**
 * Sets the image to grayscale.
 */
function OldMovieFilter() {
    this.name = "OldMovie";
    this.defaultValues = {
        amount: 7,
        density: .5,
        monochrome: true
    };
    this.valueRanges = {
        amount: { min: 0, max: 100 },
        density: { min: 0, max: 1.0 },
        monochrome: { min: false, max: true }
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;

        var density = this.defaultValues.density
        var amount = values.amount ? values.amount : this.defaultValues.amount
        var monochrome = this.defaultValues.monochrome
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;

                if (Math.random() <= density) {
                    if (monochrome) {
                        var n = parseInt((2 * Math.random() - 1) * amount);
                        inputData[pixel] += n;
                        inputData[pixel + 1] += n;
                        inputData[pixel + 2] += n;
                    } else {
                        for (var i = 0; i < 3; i++) {
                            var n = parseInt((2 * Math.random() - 1) * amount);
                            inputData[pixel + i] += n;
                        }
                    }
                }


                var luma = inputData[pixel] * 0.3 + inputData[pixel + 1] * 0.59 + inputData[pixel + 2] * 0.11;
                inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = luma;
            }
        }
    }
}

/**
 * Blurs the image with Gaussian blur.
 */
function BlurFilter() {
    this.name = "Blur";
    this.defaultValues = {
        amount: 3
    };
    this.valueRanges = {
        amount: { min: 0, max: 10 }
    };
    this.filter = function (input, values) {
        var width = input.width;
        var width4 = width << 2;
        var height = input.height;
        var inputData = input.data;
        var q;
        var amount = values.amount;
        if (amount < 0.0) {
            amount = 0.0;
        }
        if (amount >= 2.5) {
            q = 0.98711 * amount - 0.96330;
        } else if (amount >= 0.5) {
            q = 3.97156 - 4.14554 * Math.sqrt(1.0 - 0.26891 * amount);
        } else {
            q = 2 * amount * (3.97156 - 4.14554 * Math.sqrt(1.0 - 0.26891 * 0.5));
        }
        var qq = q * q;
        var qqq = qq * q;
        var b0 = 1.57825 + (2.44413 * q) + (1.4281 * qq) + (0.422205 * qqq);
        var b1 = ((2.44413 * q) + (2.85619 * qq) + (1.26661 * qqq)) / b0;
        var b2 = (-((1.4281 * qq) + (1.26661 * qqq))) / b0;
        var b3 = (0.422205 * qqq) / b0;
        var bigB = 1.0 - (b1 + b2 + b3);
        for (var c = 0; c < 3; c++) {
            for (var y = 0; y < height; y++) {
                var index = y * width4 + c;
                var indexLast = y * width4 + ((width - 1) << 2) + c;
                var pixel = inputData[index];
                var ppixel = pixel;
                var pppixel = ppixel;
                var ppppixel = pppixel;
                for (; index <= indexLast; index += 4) {
                    pixel = bigB * inputData[index] + b1 * ppixel + b2 * pppixel + b3 * ppppixel;
                    inputData[index] = pixel;
                    ppppixel = pppixel;
                    pppixel = ppixel;
                    ppixel = pixel;
                }
                index = y * width4 + ((width - 1) << 2) + c;
                indexLast = y * width4 + c;
                pixel = inputData[index];
                ppixel = pixel;
                pppixel = ppixel;
                ppppixel = pppixel;
                for (; index >= indexLast; index -= 4) {
                    pixel = bigB * inputData[index] + b1 * ppixel + b2 * pppixel + b3 * ppppixel;
                    inputData[index] = pixel;
                    ppppixel = pppixel;
                    pppixel = ppixel;
                    ppixel = pixel;
                }
            }
        }
        for (var c = 0; c < 3; c++) {
            for (var x = 0; x < width; x++) {
                var index = (x << 2) + c;
                var indexLast = (height - 1) * width4 + (x << 2) + c;
                var pixel = inputData[index];
                var ppixel = pixel;
                var pppixel = ppixel;
                var ppppixel = pppixel;
                for (; index <= indexLast; index += width4) {
                    pixel = bigB * inputData[index] + b1 * ppixel + b2 * pppixel + b3 * ppppixel;
                    inputData[index] = pixel;
                    ppppixel = pppixel;
                    pppixel = ppixel;
                    ppixel = pixel;
                }
                index = (height - 1) * width4 + (x << 2) + c;
                indexLast = (x << 2) + c;
                pixel = inputData[index];
                ppixel = pixel;
                pppixel = ppixel;
                ppppixel = pppixel;
                for (; index >= indexLast; index -= width4) {
                    pixel = bigB * inputData[index] + b1 * ppixel + b2 * pppixel + b3 * ppppixel;
                    inputData[index] = pixel;
                    ppppixel = pppixel;
                    pppixel = ppixel;
                    ppixel = pixel;
                }
            }
        }
    }
}

/**
 * Sets the image to grayscale.
 */
function GrayscaleFilter() {
    this.name = "Grayscale";
    this.defaultValues = {
    };
    this.valueRanges = {
    };
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var luma = inputData[pixel] * 0.3 + inputData[pixel + 1] * 0.59 + inputData[pixel + 2] * 0.11;
                inputData[pixel] = inputData[pixel + 1] = inputData[pixel + 2] = luma;
            }
        }
    }
}

/**
 * Creates a sepia effect on the image i.e. gives the image a yellow-brownish tone.
 */
function SepiaFilter() {
    this.name = "Sepia";
    this.defaultValues = {
        amount: 10
    };
    this.valueRanges = {
        amount: { min: 0, max: 30 }
    };
    if (!FilterUtils) {
        if (console) {
            console.error("Unable to find filterutils.js, please include this file! (Required by " + this.name + " filter)");
        }
        return;
    }
    var filterUtils = new FilterUtils();
    this.filter = function (input, values) {
        var width = input.width, height = input.height;
        var inputData = input.data;
        if (values === undefined) { values = this.defaultValues; }
        var amount = (values.amount === undefined) ? this.defaultValues.amount : values.amount;
        amount *= 255 / 100;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var pixel = (y * width + x) * 4;
                var luma = inputData[pixel] * 0.3 + inputData[pixel + 1] * 0.59 + inputData[pixel + 2] * 0.11;
                var r, g, b;
                r = g = b = luma;
                r += 40;
                g += 20;
                b -= amount;

                inputData[pixel] = r;
                inputData[pixel + 1] = g;
                inputData[pixel + 2] = b;
            }
        }
    }
}

ImageFilters.applyFilters = function (canvas, ctx, _store) {
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    // if (_store.emboss) {
    //     new EmbossFilter().filter(imageData, _store.emboss);
    // }
    // if (_store.binarize) {
    //     new EmbossFilter().filter(imageData, _store.binarize);
    // }
    if (_store.blur) {
        new BlurFilter().filter(imageData, { amount: _store.blur });
    }

    if (_store.wave) {
        new WaterRippleFilter().filter(imageData, _store.wave);
    }
    if (_store.shape) {
        if (_store.shape === 1) {
            new LineSmearFilter().filter(imageData, 10);
        }
        else if (_store.shape === 2) {
            new CircleSmearFilter().filter(imageData, 10);
        }
        else if (_store.shape === 3) {
            new SquareSmearFilter().filter(imageData, 10);
        }
    }

    if (_store.diffusion) {
        new DiffusionFilter().filter(imageData, { scale: _store.diffusion * 3 });
    }
    // if (_store.dither) {
    //     new DitherFilter().filter(imageData, { levels: _store.dither });
    // }
    // if (_store.gain) {
    //     new GainFilter().filter(imageData, _store.gain);
    // }
    // if (_store.kaleidoscope) {
    //     if (_store.kaleidoscope.angle || _store.kaleidoscope.rotation || _store.kaleidoscope.sides) {
    //         new KaleidoscopeFilter().filter(imageData, _store.kaleidoscope);
    //     }
    // }
    // if (_store.distortion && _store.distortion.refraction) {
    //     new LensDistortionFilter().filter(imageData, _store.distortion);
    // }
    // if (_store.cut && _store.cut.radius) {
    //     new LensDistortionFilter().filter(imageData, { refraction: 0, ..._store.cut });
    // }
    // if (_store.noise) {
    //     new NoiseFilter().filter(imageData, _store.noise);
    // }
    // if (_store.pinch) {
    //     if ((_store.pinch.amount !== 0 || _store.pinch.radius || _store.pinch.angle)) {
    //         new PinchFilter().filter(imageData, _store.pinch);
    //     }
    // }
    if (_store.pixelation) {
        new PixelationFilter().filter(imageData, { size: _store.pixelation });
    }
    // if (_store.color) {
    //     if (_store.color.red !== 1 || _store.color.green !== 1 || _store.color.blue !== 1) {
    //         new RGBAdjustFilter().filter(imageData, _store.color);
    //     }
    // }
    // if (_store.ripples) {
    //     // if (_store.ripples.xAmplitude || _store.ripples.yAmplitude) {
    //     //     if (_store.ripples.xWavelength === 0) {
    //     //         _store.ripples.xWavelength = 1
    //     //     }
    //     //     if (_store.ripples.yWavelength === 0) {
    //     //         _store.ripples.yWavelength = 1
    //     //     }
    //     // }
    //     new SineRippleFilter().filter(imageData, _store.ripples);
    // }
    // if (_store.sparkie) {
    //     if (_store.sparkie.rays || _store.sparkie.radius || _store.sparkie.amount) {
    //         new SparkleFilter().filter(imageData, _store.sparkie);
    //     }
    // }
    // if (_store.vignette) {
    //     new VignetteFilter().filter(imageData, _store.vignette);
    // }

    // if (_store.edge) {
    //     imageData = ImageFilters.Edge(imageData);
    //     if (_store.edge === 2) {
    //         new SolarizeFilter().filter(imageData)
    //     }
    // }

    if (_store.black) {
        new ThresholdFilter().filter(imageData, { threshold: _store.black + 50 });
    }

    // if (_store.posterize) {
    //     new PosterizeFilter().filter(imageData, { levels: _store.posterize });
    // }
    // if (_store.gamma) {
    //     new GammaFilter().filter(imageData, { amount: _store.gamma });
    // }
    if (_store.oldMovie) {
        new OldMovieFilter().filter(imageData, { amount: _store.oldMovie * 10 });
    }
    // if (_store.grayscale) {
    //     new GrayscaleFilter().filter(imageData, _store.grayscale);
    // }
    // if (_store.pencil) {


    //     new PencilFilter().filter(imageData, {
    //         height: _store.pencil,
    //         gain: 3,
    //         noise: 1
    //     });
    // }

    // if (_store.binarize) {
    //     imageData = ImageFilters.Binarize(imageData, 0.5);
    // }
    // if (_store.mosaic) {
    //     imageData = ImageFilters.Mosaic(imageData, _store.mosaic);
    // }

    if (_store.sharpen) {
        imageData = ImageFilters.Sharpen(imageData, _store.sharpen);
    }
    // imageData = ImageFilters.OpacityFilter(imageData, .1);

    // if (_store.oil) {
    //     imageData = new OilPaintFilter().filter(imageData, {
    //         intensity: _store.oil,
    //         radius: 4
    //     })
    //     //imageData = ImageFilters.Oil(imageData, _store.oil, 20);
    // }

    // if (_store.enrich) {
    //     imageData = ImageFilters.Enrich(imageData);
    // }
    if (_store.flip) {
        imageData = ImageFilters.Flip(imageData, _store.flip == 2);
    }
    // if (_store.exposure) {
    //     new ExposureFilter().filter(imageData, { exposure: _store.exposure });
    // }
    if (_store.effect) {
        if (_store.effect === 1) {
            imageData = ImageFilters.Enrich(imageData);
        }
        else if (_store.effect === 2) {
            new SolarizeFilter().filter(imageData);
        }
        else if (_store.effect === 3) {
            new GhostFilter().filter(imageData, { exposure: 4, isGray: true });
        }
        else if (_store.effect === 4) {
            new GhostFilter().filter(imageData, { exposure: 4, isGray: false });

        }
        else if (_store.effect === 5) {
            new BumpFilter().filter(imageData, _store.depth);
        }
        else if (_store.effect === 6) {
            new PosterizeFilter().filter(imageData, { levels: 5 });
        }
        else if (_store.effect === 7) {
            imageData = new OilPaintFilter().filter(imageData, {
                intensity: 1,
                radius: 4
            })
        }
        else if (_store.effect === 8) {
            imageData = ImageFilters.Binarize(imageData, 0.9);
        }
        else if (_store.effect === 9) {
            new SineRippleFilter().filter(imageData, 10);
        }
        else if (_store.effect === 10) {
            new SepiaFilter().filter(imageData, { amount: 3 });
        }
        else if (_store.effect === 11) {
            new NoiseFilter().filter(imageData, { amount: 23 });
        }
        else if (_store.effect === 12) {
            new VignetteFilter().filter(imageData, _store.vignette);
        }
        else if (_store.effect === 13) {
            new GrayscaleFilter().filter(imageData, { amount: _store.blur });
        }
    }

    if (_store.edges) {
        if (_store.edges === 1) {
            new EdgeFilter().filter(imageData);
        }
        else if (_store.edges === 2) {
            new EdgeFilter().filter(imageData);
            new SolarizeFilter().filter(imageData)
        }
        else if (_store.edges === 3) {
            new EmbossFilter().filter(imageData, 10);
            new SolarizeFilter().filter(imageData)
        }
        else if (_store.edges === 4) {
            new EmbossFilter().filter(imageData, 10);
        }
        else if (_store.edges === 5) {
            new PencilFilter().filter(imageData, {
                height: 2,
                gain: 3,
                noise: 1
            });
        }
        else if (_store.edges === 6) {
            new PencilFilter().filter(imageData, {
                height: 10,
                gain: 6,
                noise: 1
            });
        }
    }
    if (ctx) {

        if (imageData) {
            ctx.putImageData(imageData, 0, 0);
        }
        // var filter = getCanvasFilter(_store)
        // ctx.filter = filter
        // _log("getCanvasFilter", _store, ctx.filter)
    }
    return imageData
}
export default ImageFilters